<ng-container [ngSwitch]="type">
  <ng-container *ngSwitchCase="ICON_TYPE.MENU"> MENU </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.HAMBURGER_MENU">
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="3" y="4" width="14" height="2" rx="1" fill="currentColor" />
      <rect x="3" y="9" width="14" height="2" rx="1" fill="currentColor" />
      <rect
        opacity="0.4"
        x="3"
        y="14"
        width="8"
        height="2"
        rx="1"
        fill="currentColor"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.EYE_OFF">
    <svg
      class="icon"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.6799 2.23C20.9799 1.93 21.4699 1.93 21.7699 2.23C22.0799 2.53 22.0799 3.01 21.7699 3.31L3.30988 21.77C3.15988 21.92 2.96988 22 2.76988 22C2.56988 22 2.37988 21.92 2.22988 21.78C1.92988 21.48 1.92988 20.99 2.22988 20.69L5.16943 17.7489C4.28365 16.9364 3.46602 15.9593 2.75 14.84C1.75 13.27 1.75 10.72 2.75 9.14999C3.91 7.32999 5.33 5.89999 6.91 4.91999C8.49 3.95999 10.22 3.42999 12 3.42999C13.9861 3.42999 15.9166 4.08042 17.6292 5.28236L20.6799 2.23ZM14.267 8.64637C13.6216 8.20861 12.8419 7.95999 12 7.95999C9.76 7.95999 7.96 9.76999 7.96 12C7.96 12.8416 8.21408 13.6211 8.65012 14.2663L9.5144 13.4015C9.27846 12.9848 9.14014 12.505 9.14014 12C9.14014 10.43 10.4201 9.14 12.0001 9.14C12.5046 9.14 12.9839 9.27803 13.4003 9.5135L14.267 8.64637ZM21.2699 9.18C20.9799 8.72 20.6699 8.29 20.3499 7.89C19.9799 7.42 19.2799 7.38 18.8599 7.8L15.8599 10.8C16.0799 11.46 16.1199 12.22 15.9199 13.01C15.5699 14.42 14.4299 15.56 13.0199 15.91C12.2299 16.11 11.4699 16.07 10.8099 15.85L8.34995 18.31C7.84995 18.81 8.00995 19.69 8.67995 19.95C9.74995 20.36 10.8599 20.57 11.9999 20.57C13.7799 20.57 15.5099 20.05 17.0899 19.08C18.6999 18.08 20.1499 16.61 21.3199 14.74C22.2699 13.23 22.2199 10.69 21.2699 9.18ZM14.8601 12C14.8601 13.57 13.5801 14.86 12.0001 14.86H12.0001C11.9401 14.86 11.8901 14.86 11.8301 14.84L14.8401 11.83C14.8601 11.89 14.8601 11.94 14.8601 12V12Z"
        fill="currentColor"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.EYE_ON">
    <svg
      class="icon"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.25 9.14999C18.94 5.51999 15.56 3.42999 12 3.42999C10.22 3.42999 8.49 3.94999 6.91 4.91999C5.33 5.89999 3.91 7.32999 2.75 9.14999C1.75 10.72 1.75 13.27 2.75 14.84C5.06 18.48 8.44 20.56 12 20.56C13.78 20.56 15.51 20.04 17.09 19.07C18.67 18.09 20.09 16.66 21.25 14.84C22.25 13.28 22.25 10.72 21.25 9.14999ZM12 16.04C9.76 16.04 7.96 14.23 7.96 12C7.96 9.76999 9.76 7.95999 12 7.95999C14.24 7.95999 16.04 9.76999 16.04 12C16.04 14.23 14.24 16.04 12 16.04Z"
        fill="currentColor"
      />
      <path
        d="M11.9999 9.14001C10.4299 9.14001 9.1499 10.42 9.1499 12C9.1499 13.57 10.4299 14.85 11.9999 14.85C13.5699 14.85 14.8599 13.57 14.8599 12C14.8599 10.43 13.5699 9.14001 11.9999 9.14001Z"
        fill="currentColor"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.EYE_ON_OUTLINE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9833 10C12.9833 11.65 11.6499 12.9833 9.99993 12.9833C8.34993 12.9833 7.0166 11.65 7.0166 10C7.0166 8.35 8.34993 7.01666 9.99993 7.01666C11.6499 7.01666 12.9833 8.35 12.9833 10Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.99987 16.8917C12.9415 16.8917 15.6832 15.1583 17.5915 12.1583C18.3415 10.9833 18.3415 9.00834 17.5915 7.83334C15.6832 4.83334 12.9415 3.10001 9.99987 3.10001C7.0582 3.10001 4.31654 4.83334 2.4082 7.83334C1.6582 9.00834 1.6582 10.9833 2.4082 12.1583C4.31654 15.1583 7.0582 16.8917 9.99987 16.8917Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.CHEVRON_DOWN_FILL">
    <svg
      class="icon"
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.9334 6.81665H9.7417H5.0667C4.2667 6.81665 3.8667 7.78332 4.43337 8.34998L8.75003 12.6666C9.4417 13.3583 10.5667 13.3583 11.2584 12.6666L12.9 11.025L15.575 8.34998C16.1334 7.78332 15.7334 6.81665 14.9334 6.81665Z"
        fill="currentColor"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.CHEVRON_LEFT">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 6 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.6665 0.833414L1.33317 5.00008L4.6665 9.16675"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.SEARCH">
    <svg
      class="icon"
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx="8.54167"
        cy="8.74992"
        rx="5.41667"
        ry="5.41667"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="square"
      />
      <path
        d="M13.125 13.3333L16.4583 16.6666"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="square"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.TROLI">
    <svg
      class="icon"
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.6665 2.50843H3.11651C4.01651 2.50843 4.72484 3.28343 4.64984 4.1751L3.5414 12.475C3.42474 13.8333 4.49973 15 5.8664 15H17.0831"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.1667 18.3333C15.0871 18.3333 15.8333 17.5871 15.8333 16.6667C15.8333 15.7462 15.0871 15 14.1667 15C13.2462 15 12.5 15.7462 12.5 16.6667C12.5 17.5871 13.2462 18.3333 14.1667 18.3333Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.00016 18.3333C5.92064 18.3333 6.66683 17.5871 6.66683 16.6667C6.66683 15.7462 5.92064 15 5.00016 15C4.07969 15 3.3335 15.7462 3.3335 16.6667C3.3335 17.5871 4.07969 18.3333 5.00016 18.3333Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.7839 12.0833H6.25L6.87497 7.08333L7.382 3.36489C7.44956 2.86941 7.87275 2.5 8.37283 2.5H16.7711C17.377 2.5 17.8438 3.03468 17.7619 3.63511L17.2917 7.08333L16.7762 11.2074C16.7137 11.7078 16.2883 12.0833 15.7839 12.0833Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <path
        d="M11.0418 4.0942L10.8335 5.83333H12.2918H13.7502L13.9585 4.0942L14.1668 2.5H11.2501L11.0418 4.0942Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.BELL">
    <svg
      class="icon"
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0165 2.42505C7.25816 2.42505 5.0165 4.66672 5.0165 7.42505V9.83338C5.0165 10.3417 4.79983 11.1167 4.5415 11.55L3.58316 13.1417C2.9915 14.125 3.39983 15.2167 4.48316 15.5834C8.07483 16.7834 11.9498 16.7834 15.5415 15.5834C16.5498 15.25 16.9915 14.0584 16.4415 13.1417L15.4832 11.55C15.2332 11.1167 15.0165 10.3417 15.0165 9.83338V7.42505C15.0165 4.67505 12.7665 2.42505 10.0165 2.42505Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M11.5584 2.6667C11.3001 2.5917 11.0334 2.53337 10.7584 2.50003C9.95843 2.40003 9.19176 2.45837 8.4751 2.6667C8.71676 2.05003 9.31676 1.6167 10.0168 1.6167C10.7168 1.6167 11.3168 2.05003 11.5584 2.6667Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.5166 15.8833C12.5166 17.2583 11.3916 18.3833 10.0166 18.3833C9.33327 18.3833 8.69993 18.1 8.24993 17.65C7.79993 17.2 7.5166 16.5666 7.5166 15.8833"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.TICK">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.33366 2.5L3.75033 7.08333L1.66699 5"
        stroke="currentColor"
        stroke-width="1.67"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.CLOSE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99999 7.99999L4 4M8.00001 4L4 8.00001"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.LIST">
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2ZM15.75 15.75H8.25C7.84 15.75 7.5 15.41 7.5 15C7.5 14.59 7.84 14.25 8.25 14.25H15.75C16.16 14.25 16.5 14.59 16.5 15C16.5 15.41 16.16 15.75 15.75 15.75ZM15.75 9.75H8.25C7.84 9.75 7.5 9.41 7.5 9C7.5 8.59 7.84 8.25 8.25 8.25H15.75C16.16 8.25 16.5 8.59 16.5 9C16.5 9.41 16.16 9.75 15.75 9.75Z"
        fill="currentColor"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.CASH_PLUS">
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 4H7C4 4 2 5.5 2 9V12.56C2 12.93 2.38 13.16 2.71 13.01C3.69 12.56 4.82 12.39 6.01 12.6C8.64 13.07 10.57 15.51 10.5 18.18C10.49 18.6 10.43 19.01 10.32 19.41C10.24 19.72 10.49 20.01 10.81 20.01H17C20 20.01 22 18.51 22 15.01V9C22 5.5 20 4 17 4ZM12 14.5C10.62 14.5 9.5 13.38 9.5 12C9.5 10.62 10.62 9.5 12 9.5C13.38 9.5 14.5 10.62 14.5 12C14.5 13.38 13.38 14.5 12 14.5ZM19.25 14C19.25 14.41 18.91 14.75 18.5 14.75C18.09 14.75 17.75 14.41 17.75 14V10C17.75 9.59 18.09 9.25 18.5 9.25C18.91 9.25 19.25 9.59 19.25 10V14Z"
        fill="currentColor"
      />
      <path
        d="M5 14C2.79 14 1 15.79 1 18C1 18.75 1.21 19.46 1.58 20.06C2.27 21.22 3.54 22 5 22C6.46 22 7.73 21.22 8.42 20.06C8.79 19.46 9 18.75 9 18C9 15.79 7.21 14 5 14ZM6.49 18.73H5.75V19.51C5.75 19.92 5.41 20.26 5 20.26C4.59 20.26 4.25 19.92 4.25 19.51V18.73H3.51C3.1 18.73 2.76 18.39 2.76 17.98C2.76 17.57 3.1 17.23 3.51 17.23H4.25V16.52C4.25 16.11 4.59 15.77 5 15.77C5.41 15.77 5.75 16.11 5.75 16.52V17.23H6.49C6.9 17.23 7.24 17.57 7.24 17.98C7.24 18.39 6.91 18.73 6.49 18.73Z"
        fill="currentColor"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.CONTACT_OUTLINE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.4917 1.66675H6.50832C3.47499 1.66675 1.66666 3.47508 1.66666 6.50841V13.4917C1.66666 15.8334 2.74166 17.4417 4.63332 18.0501C5.18332 18.2417 5.81666 18.3334 6.50832 18.3334H13.4917C14.1833 18.3334 14.8167 18.2417 15.3667 18.0501C17.2583 17.4417 18.3333 15.8334 18.3333 13.4917V6.50841C18.3333 3.47508 16.525 1.66675 13.4917 1.66675ZM17.0833 13.4917C17.0833 15.2751 16.3833 16.4001 14.975 16.8667C14.1667 15.2751 12.25 14.1417 9.99999 14.1417C7.74999 14.1417 5.84166 15.2667 5.02499 16.8667H5.01666C3.62499 16.4167 2.91666 15.2834 2.91666 13.5001V6.50841C2.91666 4.15841 4.15832 2.91675 6.50832 2.91675H13.4917C15.8417 2.91675 17.0833 4.15841 17.0833 6.50841V13.4917Z"
        fill="currentColor"
      />
      <path
        d="M10 6.66675C8.35 6.66675 7.01666 8.00008 7.01666 9.65008C7.01666 11.3001 8.35 12.6417 10 12.6417C11.65 12.6417 12.9833 11.3001 12.9833 9.65008C12.9833 8.00008 11.65 6.66675 10 6.66675Z"
        fill="currentColor"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.ARROW">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2198_21856)">
        <path
          d="M14.4302 5.92969L20.5002 11.9997L14.4302 18.0697"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3.5 12H20.33"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.ARROW_LEFT">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_5319_113558)">
        <path
          d="M7.97533 4.94141L2.91699 9.99974L7.97533 15.0581"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.0836 10H3.05859"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.SHIELD_TICK">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.36 2.74664L8.69337 1.37331C8.31337 1.23331 7.69337 1.23331 7.31337 1.37331L3.6467 2.74664C2.94003 3.01331 2.3667 3.83998 2.3667 4.59331V9.99331C2.3667 10.5333 2.72003 11.2466 3.15337 11.5666L6.82003 14.3066C7.4667 14.7933 8.5267 14.7933 9.17337 14.3066L12.84 11.5666C13.2734 11.24 13.6267 10.5333 13.6267 9.99331V4.59331C13.6334 3.83998 13.06 3.01331 12.36 2.74664ZM10.32 6.47998L7.45337 9.34664C7.35337 9.44664 7.2267 9.49331 7.10003 9.49331C6.97337 9.49331 6.8467 9.44664 6.7467 9.34664L5.68003 8.26664C5.4867 8.07331 5.4867 7.75331 5.68003 7.55998C5.87337 7.36664 6.19337 7.36664 6.3867 7.55998L7.1067 8.27998L9.62003 5.76664C9.81337 5.57331 10.1334 5.57331 10.3267 5.76664C10.52 5.95998 10.52 6.28664 10.32 6.47998Z"
        fill="currentColor"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.QUESTION_CIRCLE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1294_23807)">
        <path
          d="M6.99935 12.8334C10.221 12.8334 12.8327 10.2217 12.8327 7.00008C12.8327 3.77842 10.221 1.16675 6.99935 1.16675C3.77769 1.16675 1.16602 3.77842 1.16602 7.00008C1.16602 10.2217 3.77769 12.8334 6.99935 12.8334Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7 9.91675H7.00583"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.30273 5.25009C5.43988 4.86023 5.71057 4.53148 6.06687 4.32208C6.42318 4.11268 6.84209 4.03614 7.24942 4.106C7.65675 4.17587 8.02621 4.38764 8.29236 4.70381C8.55851 5.01998 8.70418 5.42014 8.70357 5.83342C8.70357 7.00009 6.95357 7.58342 6.95357 7.58342"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1294_23807">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.EXCLAMATION_CIRCLE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00008 1.16663C3.78591 1.16663 1.16675 3.78579 1.16675 6.99996C1.16675 10.2141 3.78591 12.8333 7.00008 12.8333C10.2142 12.8333 12.8334 10.2141 12.8334 6.99996C12.8334 3.78579 10.2142 1.16663 7.00008 1.16663ZM6.56258 4.66663C6.56258 4.42746 6.76091 4.22913 7.00008 4.22913C7.23925 4.22913 7.43758 4.42746 7.43758 4.66663V7.58329C7.43758 7.82246 7.23925 8.02079 7.00008 8.02079C6.76091 8.02079 6.56258 7.82246 6.56258 7.58329V4.66663ZM7.53675 9.55496C7.50758 9.63079 7.46675 9.68913 7.41425 9.74746C7.35591 9.79996 7.29175 9.84079 7.22175 9.86996C7.15175 9.89913 7.07591 9.91663 7.00008 9.91663C6.92425 9.91663 6.84841 9.89913 6.77841 9.86996C6.70841 9.84079 6.64425 9.79996 6.58591 9.74746C6.53341 9.68913 6.49258 9.63079 6.46341 9.55496C6.43425 9.48496 6.41675 9.40913 6.41675 9.33329C6.41675 9.25746 6.43425 9.18163 6.46341 9.11163C6.49258 9.04163 6.53341 8.97746 6.58591 8.91913C6.64425 8.86663 6.70841 8.82579 6.77841 8.79663C6.91841 8.73829 7.08175 8.73829 7.22175 8.79663C7.29175 8.82579 7.35591 8.86663 7.41425 8.91913C7.46675 8.97746 7.50758 9.04163 7.53675 9.11163C7.56591 9.18163 7.58341 9.25746 7.58341 9.33329C7.58341 9.40913 7.56591 9.48496 7.53675 9.55496Z"
        fill="currentColor"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.EXCLAMATION_CIRCLE_OUTLINE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.0013 12.8333C10.2096 12.8333 12.8346 10.2083 12.8346 6.99999C12.8346 3.79166 10.2096 1.16666 7.0013 1.16666C3.79297 1.16666 1.16797 3.79166 1.16797 6.99999C1.16797 10.2083 3.79297 12.8333 7.0013 12.8333Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7 4.66666V7.58332"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.99609 9.33334H7.00133"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.CAMERA_PLUS_OUTLINE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28 14.6666V24.6666C28 25.7712 27.1046 26.6666 26 26.6666H6C4.89543 26.6666 4 25.7712 4 24.6666V11.3333C4 10.2287 4.89543 9.33331 6 9.33331H9C9.62951 9.33331 10.2223 9.03692 10.6 8.53331L12.4 6.13331C12.7777 5.6297 13.3705 5.33331 14 5.33331H17.6667"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24.6666 5.33331V8.66665M24.6666 12V8.66665M24.6666 8.66665H21.3333M24.6666 8.66665H27.9999"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <ellipse
        cx="16.0001"
        cy="17.3333"
        rx="5.33333"
        ry="5.33333"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.EDIT_OUTLINE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H15C20 22 22 20 22 15V13"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.0399 3.02025L8.15988 10.9003C7.85988 11.2003 7.55988 11.7903 7.49988 12.2203L7.06988 15.2303C6.90988 16.3203 7.67988 17.0803 8.76988 16.9303L11.7799 16.5003C12.1999 16.4403 12.7899 16.1403 13.0999 15.8403L20.9799 7.96025C22.3399 6.60025 22.9799 5.02025 20.9799 3.02025C18.9799 1.02025 17.3999 1.66025 16.0399 3.02025Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.9102 4.15039C15.5802 6.54039 17.4502 8.41039 19.8502 9.09039"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.TRASH_OUTLINE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 5.98047C17.67 5.65047 14.32 5.48047 10.98 5.48047C9 5.48047 7.02 5.58047 5.04 5.78047L3 5.98047"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.8504 9.13965L18.2004 19.2096C18.0904 20.7796 18.0004 21.9996 15.2104 21.9996H8.79039C6.00039 21.9996 5.91039 20.7796 5.80039 19.2096L5.15039 9.13965"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.3301 16.5H13.6601"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.5 12.5H14.5"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.CLIPBOARD_OUTLINE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66602 10.167H12.4993"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.66602 13.5H10.316"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.33268 5.00033H11.666C13.3327 5.00033 13.3327 4.16699 13.3327 3.33366C13.3327 1.66699 12.4993 1.66699 11.666 1.66699H8.33268C7.49935 1.66699 6.66602 1.66699 6.66602 3.33366C6.66602 5.00033 7.49935 5.00033 8.33268 5.00033Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.3333 3.34961C16.1083 3.49961 17.5 4.52461 17.5 8.33294V13.3329C17.5 16.6663 16.6667 18.3329 12.5 18.3329H7.5C3.33333 18.3329 2.5 16.6663 2.5 13.3329V8.33294C2.5 4.53294 3.89167 3.49961 6.66667 3.34961"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.CONTENT_OUTLINE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 5.83341V14.1667C17.5 16.6667 16.25 18.3334 13.3333 18.3334H6.66667C3.75 18.3334 2.5 16.6667 2.5 14.1667V5.83341C2.5 3.33341 3.75 1.66675 6.66667 1.66675H13.3333C16.25 1.66675 17.5 3.33341 17.5 5.83341Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.9163 1.66675V8.21674C12.9163 8.5834 12.483 8.76673 12.2163 8.52507L10.283 6.74177C10.1247 6.59177 9.87465 6.59177 9.71632 6.74177L7.78303 8.52507C7.51636 8.76673 7.08301 8.5834 7.08301 8.21674V1.66675H12.9163Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.042 11.6667H14.5837"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.5 15H14.5833"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.PRINT_OUTLINE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.04199 5.83329H13.9587V4.16663C13.9587 2.49996 13.3337 1.66663 11.4587 1.66663H8.54199C6.66699 1.66663 6.04199 2.49996 6.04199 4.16663V5.83329Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.3337 12.5V15.8333C13.3337 17.5 12.5003 18.3333 10.8337 18.3333H9.16699C7.50033 18.3333 6.66699 17.5 6.66699 15.8333V12.5H13.3337Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.5 8.33337V12.5C17.5 14.1667 16.6667 15 15 15H13.3333V12.5H6.66667V15H5C3.33333 15 2.5 14.1667 2.5 12.5V8.33337C2.5 6.66671 3.33333 5.83337 5 5.83337H15C16.6667 5.83337 17.5 6.66671 17.5 8.33337Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.1663 12.5H13.158H5.83301"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.83301 9.16663H8.33301"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.INFO_CIRCLE_OUTLINE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00065 1.16659C3.79232 1.16658 1.16732 3.79158 1.16732 6.99992C1.16732 10.2083 3.79232 12.8333 7.00065 12.8333C10.209 12.8333 12.834 10.2083 12.834 6.99992C12.834 3.79159 10.209 1.16659 7.00065 1.16659Z"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7 9.33325L7 6.41659"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.00391 4.66675L6.99867 4.66675"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.DOWNLOAD_OUTLINE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.75 11.9585V14.9585C15.75 15.3563 15.592 15.7379 15.3107 16.0192C15.0294 16.3005 14.6478 16.4585 14.25 16.4585H3.75C3.35218 16.4585 2.97064 16.3005 2.68934 16.0192C2.40804 15.7379 2.25 15.3563 2.25 14.9585V11.9585M5.25 8.2085L9 11.9585M9 11.9585L12.75 8.2085M9 11.9585V2.9585"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.FILTER_OUTLINE">
    <svg width="100%" height="100%" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.50065 1.75H15.5007C16.4173 1.75 17.1673 2.5 17.1673 3.41667V5.25C17.1673 5.91667 16.7507 6.75 16.334 7.16667L12.7507 10.3333C12.2507 10.75 11.9173 11.5833 11.9173 12.25V15.8333C11.9173 16.3333 11.584 17 11.1673 17.25L10.0007 18C8.91732 18.6667 7.41732 17.9167 7.41732 16.5833V12.1667C7.41732 11.5833 7.08398 10.8333 6.75065 10.4167L3.58398 7.08333C3.16732 6.66667 2.83398 5.91667 2.83398 5.41667V3.5C2.83398 2.5 3.58398 1.75 4.50065 1.75Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M9.10833 1.75L5 8.33333" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>      
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.ROTATE_LEFT_OUTLINE">
    <svg width="100%" height="100%" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2 8C2 9.18669 2.35189 10.3467 3.01118 11.3334C3.67047 12.3201 4.60754 13.0892 5.7039 13.5433C6.80026 13.9974 8.00666 14.1162 9.17054 13.8847C10.3344 13.6532 11.4035 13.0818 12.2426 12.2426C13.0818 11.4035 13.6532 10.3344 13.8847 9.17054C14.1162 8.00666 13.9974 6.80026 13.5433 5.7039C13.0892 4.60754 12.3201 3.67047 11.3334 3.01118C10.3467 2.35189 9.18669 2 8 2C6.32263 2.00631 4.71265 2.66082 3.50667 3.82667L2 5.33333M2 5.33333V2M2 5.33333H5.33333" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>           
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.C_MAP">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.5404 20.0001C19.1854 20.0001 21.0857 17.5103 20.3343 15.0294L19.5116 12.313C19.0138 10.6693 17.4701 9.54167 15.7177 9.54167L5.26425 9.54167C3.50319 9.54167 1.95406 10.6802 1.46375 12.3349L0.658819 15.0514C-0.0748771 17.5274 1.82407 20.0001 4.45932 20.0001L16.5404 20.0001Z"
        fill="url(#paint0_linear_1341_64566)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.5103 14.2784C13.8458 14.2784 16.5498 9.17137 16.5498 5.90831C16.5498 2.64524 13.8458 0 10.5103 0C7.17471 0 4.4707 2.64524 4.4707 5.90831C4.4707 9.17137 7.17471 14.2784 10.5103 14.2784ZM10.5105 7.87759C11.6224 7.87759 12.5237 6.99585 12.5237 5.90816C12.5237 4.82047 11.6224 3.93872 10.5105 3.93872C9.39865 3.93872 8.49731 4.82047 8.49731 5.90816C8.49731 6.99585 9.39865 7.87759 10.5105 7.87759Z"
        fill="url(#paint1_linear_1341_64566)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1341_64566"
          x1="10.5"
          y1="9.54163"
          x2="10.5"
          y2="20"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF7787" />
          <stop offset="1" stop-color="#E52138" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1341_64566"
          x1="10.5103"
          y1="0"
          x2="10.5103"
          y2="14.2784"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF7787" />
          <stop offset="1" stop-color="#E52138" />
        </linearGradient>
      </defs>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.C_CALCULATOR">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.58039 19.9427C7.80281 19.983 9.02524 20.0098 10.2477 19.983C11.3179 20.0178 12.3881 19.9923 13.4322 19.9674L13.4356 19.9673C13.596 19.9635 13.7558 19.9597 13.9149 19.9561C14.8284 19.9293 15.7418 19.8622 16.6419 19.6475C18.0389 19.3121 19.0733 18.5607 19.624 17.2055C19.9196 16.5078 20.0405 15.7564 20.1076 15.0051C20.2165 13.9293 20.2273 12.8645 20.2382 11.791V11.791L20.242 11.436C20.2554 9.90638 20.2554 8.36336 20.2151 6.82033C20.1882 5.89452 20.1345 4.96871 19.9733 4.05632C19.7987 3.03658 19.436 2.11077 18.6568 1.38622C17.9718 0.742176 17.1255 0.446989 16.2254 0.285978C14.9224 0.0444619 13.606 0.0310443 12.2895 0.0176268C10.5432 -0.00920837 8.78344 -0.00920836 7.03712 0.0444619C6.11023 0.0712971 5.18334 0.124967 4.26988 0.285978C3.26239 0.460407 2.3355 0.809263 1.62354 1.58748C0.992178 2.2852 0.696647 3.1305 0.522016 4.0429C0.317482 5.1485 0.296138 6.2541 0.274608 7.36934C0.2721 7.49928 0.269588 7.62935 0.266785 7.75956C0.239918 9.75878 0.239918 11.758 0.307084 13.7572C0.347384 14.6428 0.41455 15.5418 0.629481 16.4139C1.00561 18.024 1.95937 19.0974 3.55792 19.5536C4.53854 19.8354 5.55947 19.9025 6.58039 19.9427ZM8.17161 14.538C8.33994 14.6926 8.42411 14.8753 8.41008 15.0581C8.41008 15.4235 8.25578 15.6484 7.9612 15.8031C7.66663 15.9296 7.38608 15.8874 7.14761 15.6625C6.86706 15.3954 6.57248 15.1143 6.30596 14.8191C6.15166 14.6364 6.05347 14.6645 5.89917 14.8191C5.63264 15.1143 5.35209 15.3954 5.05752 15.6625C4.80502 15.8874 4.48239 15.9296 4.20184 15.775C3.93532 15.6203 3.76699 15.3251 3.80907 15.0159C3.83713 14.8191 3.93532 14.6504 4.0756 14.5099L4.77697 13.807C4.91263 13.6711 4.97924 13.6044 4.97864 13.5382C4.97807 13.4744 4.91497 13.4112 4.791 13.287L4.06157 12.556C3.72491 12.2046 3.71088 11.7548 4.01949 11.4456C4.32809 11.1363 4.791 11.1504 5.12766 11.4877C5.4082 11.7548 5.68875 12.0359 5.95528 12.3171C6.06749 12.4295 6.13763 12.4295 6.24985 12.3171C6.42804 12.1291 6.61251 11.9474 6.79485 11.7678L6.79498 11.7677C6.88533 11.6787 6.97515 11.5903 7.06344 11.5018C7.21775 11.3472 7.38608 11.2206 7.61052 11.2206C7.91912 11.2066 8.17161 11.319 8.31189 11.6002C8.46619 11.8954 8.45216 12.1905 8.22772 12.4436C7.94717 12.7528 7.66663 13.048 7.35802 13.3291C7.20372 13.4837 7.18969 13.5681 7.35802 13.7227C7.5456 13.9013 7.7269 14.0861 7.90613 14.2689C7.99497 14.3594 8.08329 14.4495 8.17161 14.538ZM6.85239 4.15038V3.6584C6.83837 3.18048 6.54379 2.87123 6.10894 2.85718C5.68811 2.85718 5.36548 3.19453 5.36548 3.64434C5.36548 3.75732 5.36391 3.8703 5.36234 3.98275C5.35923 4.20608 5.35615 4.42732 5.36548 4.64235C5.37951 4.86726 5.29535 4.9516 5.07091 4.93754C4.8454 4.92812 4.6199 4.93132 4.39861 4.93446H4.39856H4.39851L4.39846 4.93446C4.28943 4.93601 4.18143 4.93754 4.07496 4.93754C3.61205 4.93754 3.27539 5.26084 3.27539 5.68254C3.27539 6.10423 3.61205 6.42753 4.07496 6.42753H5.12702C5.30937 6.42753 5.36548 6.49781 5.36548 6.68055C5.35615 6.91432 5.35923 7.15431 5.36234 7.39638C5.36391 7.5182 5.36548 7.64055 5.36548 7.7629C5.37951 8.19865 5.71617 8.53601 6.12296 8.53601C6.52976 8.53601 6.85239 8.19865 6.86642 7.77695C6.88045 7.42554 6.88045 7.07413 6.86642 6.72272C6.86642 6.51187 6.92253 6.42753 7.14697 6.44159C7.37192 6.45098 7.60314 6.44782 7.83225 6.44469C7.94602 6.44313 8.05927 6.44159 8.17097 6.44159C8.63388 6.44159 8.95651 6.11829 8.95651 5.68254C8.95651 5.26084 8.63388 4.9516 8.185 4.93754H7.10489C6.92253 4.93754 6.85239 4.86726 6.86642 4.68452C6.85239 4.5299 6.85239 4.33311 6.85239 4.15038ZM12.4217 14.3413H14.4417C15.115 14.3413 15.7883 14.3413 16.4617 14.3554C16.9386 14.3554 17.2612 14.6646 17.2752 15.0863C17.2893 15.508 16.9386 15.8454 16.4617 15.8454H12.4217C11.9448 15.8454 11.6082 15.5221 11.6082 15.0863C11.6082 14.6365 11.9308 14.3413 12.4217 14.3413ZM14.4418 4.96567H12.3938C11.9169 4.96567 11.6083 5.27492 11.5942 5.71067C11.5942 6.14642 11.9309 6.46972 12.4078 6.46972H16.4477C16.9247 6.46972 17.2754 6.13236 17.2613 5.71067C17.2473 5.28897 16.9247 4.97973 16.4618 4.97973C15.9568 4.95864 15.4518 4.96128 14.9468 4.96392H14.9468C14.7785 4.96479 14.6101 4.96567 14.4418 4.96567ZM12.4219 11.2207H14.4418C15.1151 11.2207 15.7884 11.2207 16.4758 11.2348C16.9527 11.2348 17.3034 11.5721 17.2894 11.9938C17.2754 12.4155 16.9387 12.7247 16.4758 12.7247H12.3798C12.0151 12.7247 11.7345 12.4998 11.6363 12.1625C11.5521 11.8532 11.6784 11.5159 11.9589 11.3332C12.0992 11.2348 12.2535 11.2207 12.4219 11.2207Z"
        fill="url(#paint0_linear_1341_64574)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1341_64574"
          x1="10.25"
          y1="0"
          x2="10.25"
          y2="20"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF7787" />
          <stop offset="1" stop-color="#E52138" />
        </linearGradient>
      </defs>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.C_PREMIUM">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.5 0C2.29086 0 0.5 1.79086 0.5 4V16C0.5 18.2091 2.29086 20 4.5 20H16.5C18.7091 20 20.5 18.2091 20.5 16V4C20.5 1.79086 18.7091 0 16.5 0H4.5ZM12.5925 6.99572L11.5366 4.86651C10.9666 3.71116 10.0307 3.71116 9.45481 4.86651L8.39893 6.99572C8.25494 7.29212 7.87099 7.57642 7.55302 7.63086L5.63923 7.95145C4.41537 8.15712 4.1334 9.05236 5.0093 9.9355L6.49714 11.4356C6.74911 11.6897 6.8871 12.1796 6.8091 12.5305L6.38315 14.3875C6.04719 15.8513 6.8271 16.426 8.11096 15.6578L9.90476 14.5871C10.2347 14.3935 10.7687 14.3935 11.0926 14.5871L12.8864 15.6578C14.1763 16.426 14.9502 15.8574 14.6142 14.3875L14.1883 12.5305C14.1103 12.1796 14.2483 11.6897 14.5003 11.4356L15.9881 9.9355C16.87 9.05236 16.582 8.15712 15.3582 7.95145L13.4444 7.63086C13.1204 7.57642 12.7364 7.29212 12.5925 6.99572Z"
        fill="url(#paint0_linear_1341_65426)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1341_65426"
          x1="10.5"
          y1="0"
          x2="10.5"
          y2="20"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF7787" />
          <stop offset="1" stop-color="#E52138" />
        </linearGradient>
      </defs>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.C_LARTAS">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M14.9067 0H5.59444C2.21667 0 0.25 1.78 0.25 4.83V15.16C0.25 18.26 2.21667 20 5.59444 20H14.9067C18.3389 20 20.25 18.26 20.25 15.16V4.83C20.25 1.78 18.3389 0 14.9067 0Z"
        fill="url(#paint0_linear_1341_65431)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.89539 4.64844V4.65844C5.4165 4.65844 5.02872 5.00844 5.02872 5.43844C5.02872 5.86844 5.4165 6.21844 5.89539 6.21844H9.2165C9.69539 6.21844 10.0843 5.86844 10.0843 5.42744C10.0843 4.99844 9.69539 4.64844 9.2165 4.64844H5.89539ZM14.6063 10.7368H5.89515C5.41626 10.7368 5.02848 10.3868 5.02848 9.95678C5.02848 9.52678 5.41626 9.17578 5.89515 9.17578H14.6063C15.084 9.17578 15.4729 9.52678 15.4729 9.95678C15.4729 10.3868 15.084 10.7368 14.6063 10.7368ZM14.6065 15.3084H5.89538C5.56204 15.3484 5.23982 15.1984 5.06204 14.9484C4.88427 14.6884 4.88427 14.3584 5.06204 14.1084C5.23982 13.8484 5.56204 13.7084 5.89538 13.7384H14.6065C15.0498 13.7784 15.3843 14.1184 15.3843 14.5284C15.3843 14.9274 15.0498 15.2684 14.6065 15.3084Z"
        fill="url(#paint1_linear_1341_65431)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1341_65431"
          x1="10.25"
          y1="0"
          x2="10.25"
          y2="20"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF7787" />
          <stop offset="1" stop-color="#E52138" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1341_65431"
          x1="10.2008"
          y1="4.64844"
          x2="10.2008"
          y2="15.3149"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF7787" />
          <stop offset="1" stop-color="#E52138" />
        </linearGradient>
      </defs>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.NAV_DASHBOARD">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.75261 2.00396C7.15606 1.95367 7.51548 2.39095 7.51548 2.81702V6.16477C7.51548 6.95562 7.94822 7.14293 8.47285 6.57803L8.47581 6.57506C8.71886 6.3164 9.08935 6.33721 9.2998 6.61966L9.59916 7.02103C9.83924 7.33916 10.2275 7.33916 10.4676 7.02103L10.767 6.61966C10.9804 6.33424 11.3509 6.31343 11.5939 6.57506C12.1215 7.13996 12.5513 6.95265 12.5513 6.1618V2.81702C12.5523 2.39073 12.9122 1.95383 13.3158 2.00417C13.8874 2.07544 14.4573 2.1654 15.0248 2.27403L15.5083 2.3666C16.3779 2.53305 17.08 3.20634 17.3157 4.0997C17.6671 5.4316 17.8952 6.78984 18 8.15593C17.6824 8.00424 17.3294 7.91974 16.9576 7.91974H12.5513C11.1607 7.91974 10.0334 9.10192 10.0334 10.5602V16.5013C10.0334 17.0563 10.1966 17.5713 10.4755 17.9963C8.65772 18.0266 6.83775 17.8699 5.042 17.5262L4.55845 17.4336C3.68892 17.2672 2.98677 16.5939 2.75107 15.7005C1.74964 11.9049 1.74964 7.89533 2.75107 4.0997C2.98677 3.20634 3.68892 2.53305 4.55845 2.3666L5.04201 2.27403C5.61006 2.16529 6.18054 2.07527 6.75261 2.00396ZM4.3681 13.2007C4.3681 12.8361 4.64992 12.5406 4.99757 12.5406C5.34523 12.5406 5.62705 12.8361 5.62705 13.2007V14.5209C5.62705 14.8855 5.34523 15.1811 4.99757 15.1811C4.64992 15.1811 4.3681 14.8855 4.3681 14.5209V13.2007ZM6.88601 12.5406C6.53835 12.5406 6.25653 12.8361 6.25653 13.2007V14.5209C6.25653 14.8855 6.53835 15.1811 6.88601 15.1811C7.23366 15.1811 7.51548 14.8855 7.51548 14.5209V13.2007C7.51548 12.8361 7.23366 12.5406 6.88601 12.5406ZM8.14496 13.2007C8.14496 12.8361 8.42679 12.5406 8.77444 12.5406C9.12209 12.5406 9.40391 12.8361 9.40391 13.2007V14.5209C9.40391 14.8855 9.12209 15.1811 8.77444 15.1811C8.42679 15.1811 8.14496 14.8855 8.14496 14.5209V13.2007Z"
        attr.fill="url({{ '#paint0_linear_1995_39174' + unique }})"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.2598 10.5547C11.2598 9.80694 11.8109 9.20081 12.4908 9.20081H16.7995C17.4794 9.20081 18.0306 9.80694 18.0306 10.5547V16.647C18.0306 17.3947 17.4794 18.0008 16.7995 18.0008H12.4908C11.8109 18.0008 11.2598 17.3947 11.2598 16.647V10.5547ZM12.3998 11.2315C12.3998 10.8576 12.6753 10.5546 13.0153 10.5546H16.1842C16.5242 10.5546 16.7998 10.8576 16.7998 11.2315C16.7998 11.6053 16.5242 11.9084 16.1842 11.9084H13.0153C12.6753 11.9084 12.3998 11.6053 12.3998 11.2315ZM13.0153 13.2621C12.6753 13.2621 12.3998 13.5651 12.3998 13.939C12.3998 14.3128 12.6753 14.6159 13.0153 14.6159H15.3842C15.7242 14.6159 15.9998 14.3128 15.9998 13.939C15.9998 13.5651 15.7242 13.2621 15.3842 13.2621H13.0153Z"
        attr.fill="url({{ '#paint1_linear_1995_39174' + unique }})"
      />
      <defs>
        <linearGradient
          attr.id="{{ 'paint0_linear_1995_39174' + unique }}"
          x1="10"
          y1="2"
          x2="10"
          y2="18"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="var(--gradient1)" />
          <stop offset="1" stop-color="var(--gradient2)" />
        </linearGradient>
        <linearGradient
          id="{{ 'paint1_linear_1995_39174' + unique }}"
          x1="14.6452"
          y1="9.20081"
          x2="14.6452"
          y2="18.0008"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="var(--gradient1)" />
          <stop offset="1" stop-color="var(--gradient1)" />
        </linearGradient>
      </defs>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.NAV_PICKUP">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1995_39353)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.7622 6.45853C17.085 6.45853 17.898 8.31675 18.1303 10.6395V13.0784C18.1303 14.2398 17.4334 15.1689 16.5043 15.7496C16.4462 15.7496 16.3882 15.7787 16.3301 15.8077C16.272 15.8367 16.214 15.8658 16.1559 15.8658C16.1559 15.9819 16.0398 15.9819 16.0398 15.9819C16.0398 16.0981 15.9236 16.0981 15.8075 16.0981C15.6913 16.2142 15.5752 16.2142 15.4591 16.2142H11.3942C10.5812 16.2142 9.8844 15.5174 9.8844 14.7044C9.8844 13.8914 10.5812 13.1946 11.3942 13.1946H14.9945C15.4591 13.1946 15.8075 12.8462 15.8075 12.3816V9.71042C15.8075 9.362 15.5752 9.12972 15.2268 9.12972C14.8784 9.12972 14.6461 9.362 14.6461 9.71042V12.0332H13.0202V10.0588C13.0202 8.7813 11.9749 7.61992 10.5812 7.61992H8.02618C8.49073 7.2715 9.18757 7.03922 10.0005 6.80694C9.07143 6.22625 8.49073 5.29714 8.49073 4.25189C8.49073 2.39367 10.0005 1 11.7426 1C13.4847 1 14.8784 2.39367 14.9945 4.13575C14.9945 5.06486 14.6461 5.87783 13.9493 6.45853H14.7622ZM9.8844 5.06486C9.8844 5.87783 10.5812 6.57467 11.3942 6.57467C12.2072 6.57467 12.904 5.87783 12.904 5.06486H9.8844Z"
          attr.fill="url({{ '#paint0_linear_1995_39353' + unique }})"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.3935 12.0317H11.9742V10.1734C11.9742 9.47661 11.3935 8.77978 10.5805 8.77978H8.37389V12.1478C8.37389 12.3801 8.14162 12.3801 8.02548 12.2639C7.93214 12.2017 7.84713 12.1478 7.76823 12.0978C7.55263 11.9611 7.38254 11.8533 7.21251 11.6832C6.98023 11.451 6.86409 11.451 6.63181 11.6832C6.39953 11.7994 6.16726 12.0317 5.93498 12.2639C5.87691 12.2639 5.81884 12.293 5.76077 12.322C5.7027 12.351 5.64463 12.3801 5.58656 12.3801C5.47042 12.2639 5.47042 12.1478 5.47042 11.9155V8.77978H3.26378C2.45081 8.77978 1.87012 9.36047 1.87012 10.1734V17.6063C1.87012 18.3032 2.45081 19 3.26378 19H10.6967C11.3935 19 12.0903 18.4193 12.0903 17.7225H11.3935C9.8837 17.7225 8.72231 16.5611 8.72231 15.0513C8.72231 13.5415 9.8837 12.0317 11.3935 12.0317ZM4.07676 17.0256C4.07676 17.3741 3.84448 17.6063 3.49606 17.6063C3.14764 17.6063 2.91537 17.3741 2.91537 17.0256V15.7481C2.91537 15.3997 3.14764 15.1674 3.49606 15.1674C3.84448 15.1674 4.07676 15.3997 4.07676 15.7481V17.0256ZM5.7027 17.0256C5.7027 17.3741 5.47042 17.6063 5.12201 17.6063C4.77359 17.6063 4.54131 17.3741 4.54131 17.0256V15.7481C4.54131 15.3997 4.77359 15.1674 5.12201 15.1674C5.47042 15.1674 5.7027 15.3997 5.7027 15.7481V17.0256ZM7.21251 17.0256C7.21251 17.3741 6.98023 17.6063 6.63181 17.6063C6.28339 17.6063 6.05112 17.3741 6.05112 17.0256V15.7481C6.05112 15.3997 6.28339 15.1674 6.63181 15.1674C6.98023 15.1674 7.21251 15.3997 7.21251 15.7481V17.0256Z"
          attr.fill="url({{ '#paint1_linear_1995_39353' + unique }})"
        />
        <path
          d="M15.1114 17.4918H13.1371C13.1371 17.9564 13.0209 18.4209 12.7887 18.7694H15.8083C16.5051 18.7694 16.9697 18.1887 16.9697 17.4918V17.1434C16.2728 17.3757 15.6921 17.4918 15.1114 17.4918Z"
          attr.fill="url({{ '#paint2_linear_1995_39353' + unique }})"
        />
      </g>
      <defs>
        <linearGradient
          id="{{ 'paint0_linear_1995_39353' + unique }}"
          x1="10.0002"
          y1="1"
          x2="10.0002"
          y2="19"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="var(--gradient1)" />
          <stop offset="1" stop-color="var(--gradient2)" />
        </linearGradient>
        <linearGradient
          id="{{ 'paint1_linear_1995_39353' + unique }}"
          x1="10.0002"
          y1="1"
          x2="10.0002"
          y2="19"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="var(--gradient1)" />
          <stop offset="1" stop-color="var(--gradient2)" />
        </linearGradient>
        <linearGradient
          id="{{ 'paint2_linear_1995_39353' + unique }}"
          x1="10.0002"
          y1="1"
          x2="10.0002"
          y2="19"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="var(--gradient1)" />
          <stop offset="1" stop-color="var(--gradient2)" />
        </linearGradient>
        <clipPath id="clip0_1995_39353">
          <rect width="100%" height="100%" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.NAV_HANDOVER">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_6414_39757)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.7622 6.45853C17.085 6.45853 17.898 8.31675 18.1303 10.6395V13.0784C18.1303 14.2398 17.4334 15.1689 16.5043 15.7496C16.4462 15.7496 16.3882 15.7787 16.3301 15.8077C16.272 15.8367 16.214 15.8658 16.1559 15.8658C16.1559 15.9819 16.0398 15.9819 16.0398 15.9819C16.0398 16.0981 15.9236 16.0981 15.8075 16.0981C15.6913 16.2142 15.5752 16.2142 15.4591 16.2142H11.3942C10.5812 16.2142 9.8844 15.5174 9.8844 14.7044C9.8844 13.8914 10.5812 13.1946 11.3942 13.1946H14.9945C15.4591 13.1946 15.8075 12.8462 15.8075 12.3816V9.71042C15.8075 9.362 15.5752 9.12972 15.2268 9.12972C14.8784 9.12972 14.6461 9.362 14.6461 9.71042V12.0332H13.0202V10.0588C13.0202 8.7813 11.9749 7.61992 10.5812 7.61992H8.02618C8.49073 7.2715 9.18757 7.03922 10.0005 6.80694C9.07143 6.22625 8.49073 5.29714 8.49073 4.25189C8.49073 2.39367 10.0005 1 11.7426 1C13.4847 1 14.8784 2.39367 14.9945 4.13575C14.9945 5.06486 14.6461 5.87783 13.9493 6.45853H14.7622ZM9.8844 5.06486C9.8844 5.87783 10.5812 6.57467 11.3942 6.57467C12.2072 6.57467 12.904 5.87783 12.904 5.06486H9.8844Z"
          attr.fill="url({{ '#paint0_linear_6414_39757' + unique }})"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.3935 12.0317H11.9742V10.1734C11.9742 9.47661 11.3935 8.77978 10.5805 8.77978H8.37389V12.1478C8.37389 12.3801 8.14162 12.3801 8.02548 12.2639C7.93214 12.2017 7.84713 12.1478 7.76823 12.0978C7.55263 11.9611 7.38254 11.8533 7.21251 11.6832C6.98023 11.451 6.86409 11.451 6.63181 11.6832C6.39953 11.7994 6.16726 12.0317 5.93498 12.2639C5.87691 12.2639 5.81884 12.293 5.76077 12.322C5.7027 12.351 5.64463 12.3801 5.58656 12.3801C5.47042 12.2639 5.47042 12.1478 5.47042 11.9155V8.77978H3.26378C2.45081 8.77978 1.87012 9.36047 1.87012 10.1734V17.6063C1.87012 18.3032 2.45081 19 3.26378 19H10.6967C11.3935 19 12.0903 18.4193 12.0903 17.7225H11.3935C9.8837 17.7225 8.72231 16.5611 8.72231 15.0513C8.72231 13.5415 9.8837 12.0317 11.3935 12.0317ZM4.07676 17.0256C4.07676 17.3741 3.84448 17.6063 3.49606 17.6063C3.14764 17.6063 2.91537 17.3741 2.91537 17.0256V15.7481C2.91537 15.3997 3.14764 15.1674 3.49606 15.1674C3.84448 15.1674 4.07676 15.3997 4.07676 15.7481V17.0256ZM5.7027 17.0256C5.7027 17.3741 5.47042 17.6063 5.12201 17.6063C4.77359 17.6063 4.54131 17.3741 4.54131 17.0256V15.7481C4.54131 15.3997 4.77359 15.1674 5.12201 15.1674C5.47042 15.1674 5.7027 15.3997 5.7027 15.7481V17.0256ZM7.21251 17.0256C7.21251 17.3741 6.98023 17.6063 6.63181 17.6063C6.28339 17.6063 6.05112 17.3741 6.05112 17.0256V15.7481C6.05112 15.3997 6.28339 15.1674 6.63181 15.1674C6.98023 15.1674 7.21251 15.3997 7.21251 15.7481V17.0256Z"
          attr.fill="url({{ '#paint1_linear_6414_39757' + unique }})"
        />
        <path
          d="M15.1114 17.4918H13.1371C13.1371 17.9564 13.0209 18.4209 12.7887 18.7694H15.8083C16.5051 18.7694 16.9697 18.1887 16.9697 17.4918V17.1434C16.2728 17.3757 15.6921 17.4918 15.1114 17.4918Z"
          attr.fill="url({{ '#paint2_linear_6414_39757' + unique }})"
        />
      </g>
      <defs>
        <linearGradient
          id="{{ 'paint0_linear_6414_39757' + unique }}"
          x1="10.0002"
          y1="1"
          x2="10.0002"
          y2="19"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="var(--gradient1)" />
          <stop offset="1" stop-color="var(--gradient2)" />
        </linearGradient>
        <linearGradient
          id="{{ 'paint1_linear_6414_39757' + unique }}"
          x1="10.0002"
          y1="1"
          x2="10.0002"
          y2="19"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="var(--gradient1)" />
          <stop offset="1" stop-color="var(--gradient2)" />
        </linearGradient>
        <linearGradient
          id="{{ 'paint2_linear_6414_39757' + unique }}"
          x1="10.0002"
          y1="1"
          x2="10.0002"
          y2="19"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="var(--gradient1)" />
          <stop offset="1" stop-color="var(--gradient2)" />
        </linearGradient>
        <clipPath id="clip0_6414_39757">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.NAV_HOME">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.6093 2.21579L17.3835 6.92038C18.025 7.44688 18.4416 8.55934 18.3083 9.39155L17.2002 16.1512C17.0002 17.3486 15.8587 18.3337 14.6672 18.3337H14.1865C13.2555 18.3337 12.5494 17.4944 12.7086 16.5771L12.8271 15.895C12.8357 15.8454 12.8444 15.7957 12.8531 15.7457C13.0995 14.3343 13.3746 12.759 12.4235 11.7048C11.8358 11.0534 10.968 10.6414 9.99984 10.6414C9.03171 10.6414 8.16383 11.0534 7.57614 11.7048C6.62503 12.759 6.90012 14.3343 7.14659 15.7457C7.15532 15.7957 7.16401 15.8454 7.17261 15.895L7.29103 16.5771C7.45028 17.4944 6.74415 18.3337 5.81314 18.3337H5.33528C4.13546 18.3337 3.0023 17.3571 2.80233 16.1512L1.69416 9.39155C1.55252 8.55934 1.96912 7.44688 2.61902 6.92038L8.39315 2.2073C9.27635 1.48548 10.7178 1.48548 11.6093 2.21579ZM11.9229 6.7952C11.9229 7.85728 11.0619 8.71827 9.99984 8.71827C8.93775 8.71827 8.07676 7.85728 8.07676 6.7952C8.07676 5.73311 8.93775 4.87212 9.99984 4.87212C11.0619 4.87212 11.9229 5.73311 11.9229 6.7952Z"
        attr.fill="url({{ '#paint0_linear_2157_23295' + unique }})"
      />
      <defs>
        <linearGradient
          id="{{ 'paint0_linear_2157_23295' + unique }}"
          x1="9.99984"
          y1="1.66699"
          x2="9.99984"
          y2="18.3337"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="var(--gradient1)" />
          <stop offset="1" stop-color="var(--gradient2)" />
        </linearGradient>
      </defs>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.NAV_INBOUND">
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.38841 2.60611C7.38841 2.1628 6.99585 1.71364 6.55602 1.76906C5.97634 1.84209 5.39826 1.93363 4.82258 2.04367L4.32097 2.13955C3.41897 2.31196 2.69061 3.00939 2.4461 3.93476C1.40729 7.86641 1.40729 12.0196 2.4461 15.9513C2.69061 16.8766 3.41897 17.5741 4.32097 17.7465L4.82257 17.8424C6.75393 18.2115 8.71229 18.3724 10.6672 18.3251C9.86364 17.4843 9.32813 16.3851 9.19786 15.1649C9.07809 15.3165 8.89701 15.4132 8.69437 15.4132C8.33373 15.4132 8.04139 15.1071 8.04139 14.7294V13.3619C8.04139 12.9842 8.33373 12.6781 8.69437 12.6781C9.01359 12.6781 9.2793 12.918 9.33612 13.235C9.93536 10.8957 12.0576 9.16654 14.5837 9.16654C16.0336 9.16654 17.3505 9.73623 18.3226 10.664C18.3918 8.40329 18.1357 6.13435 17.5545 3.93476C17.31 3.00939 16.5817 2.31196 15.6797 2.13955L15.1781 2.04367C14.603 1.93374 14.0255 1.84227 13.4464 1.76927C13.0063 1.71381 12.6133 2.16259 12.6122 2.60611V6.07075C12.6122 6.88994 12.1664 7.08396 11.6191 6.49882C11.367 6.22781 10.9827 6.24937 10.7613 6.54502L10.4507 6.96077C10.2017 7.2903 9.79892 7.2903 9.54988 6.96077L9.23934 6.54502C9.02104 6.25245 8.63671 6.23089 8.38459 6.49882L8.38151 6.5019C7.8373 7.08704 7.38841 6.89302 7.38841 6.07383V2.60611ZM4.77649 12.6781C4.41586 12.6781 4.12351 12.9842 4.12351 13.3619V14.7294C4.12351 15.1071 4.41586 15.4132 4.77649 15.4132C5.13712 15.4132 5.42947 15.1071 5.42947 14.7294V13.3619C5.42947 12.9842 5.13712 12.6781 4.77649 12.6781ZM6.08245 13.3619C6.08245 12.9842 6.3748 12.6781 6.73543 12.6781C7.09606 12.6781 7.38841 12.9842 7.38841 13.3619V14.7294C7.38841 15.1071 7.09606 15.4132 6.73543 15.4132C6.3748 15.4132 6.08245 15.1071 6.08245 14.7294V13.3619ZM14.5837 18.3334C16.7265 18.3334 18.3337 16.7263 18.3337 14.5834C18.3337 12.4406 16.7265 10.8334 14.5837 10.8334C12.4408 10.8334 10.8337 12.5123 10.8337 14.5834C10.8337 16.6545 12.4408 18.3334 14.5837 18.3334ZM14.5838 12.4406C14.2879 12.4406 14.0481 12.6805 14.0481 12.9763V14.5835C14.0481 14.8793 14.2879 15.1192 14.5838 15.1192C14.8797 15.1192 15.1195 14.8793 15.1195 14.5835V12.9763C15.1195 12.6805 14.8797 12.4406 14.5838 12.4406ZM14.0481 16.1905C14.0481 15.8947 14.2879 15.6548 14.5838 15.6548C14.8797 15.6548 15.1195 15.8947 15.1195 16.1905C15.1195 16.4864 14.8797 16.7262 14.5838 16.7262C14.2879 16.7262 14.0481 16.4864 14.0481 16.1905Z"
        attr.fill="url({{ '#paint0_linear_6414_39831' + unique }})"
      />
      <defs>
        <linearGradient
          id="{{ 'paint0_linear_6414_39831' + unique }}"
          x1="10.0003"
          y1="1.7644"
          x2="10.0003"
          y2="18.3334"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="var(--gradient1)" />
          <stop offset="1" stop-color="var(--gradient2)" />
        </linearGradient>
      </defs>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.NAV_MANIFEST">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.37378 3C5.37378 2.44772 5.82149 2 6.37378 2H12.3738C12.9261 2 13.3738 2.44772 13.3738 3C13.3738 3.55228 12.9261 4 12.3738 4H6.37378C5.82149 4 5.37378 3.55228 5.37378 3Z"
        attr.fill="url({{ '#paint0_linear_4042_12978' + unique }})"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.6275 11.451C15.6275 11.2382 15.8159 11.0226 16.027 11.0492C16.3053 11.0843 16.5828 11.1282 16.8591 11.181L17.0999 11.2271C17.5328 11.3098 17.8824 11.6446 17.9998 12.0888C18.4984 13.976 18.4984 15.9695 17.9998 17.8567C17.8824 18.3009 17.5328 18.6356 17.0999 18.7184L16.8591 18.7644C15.2158 19.0785 13.5318 19.0785 11.8885 18.7644L11.6477 18.7184C11.2147 18.6356 10.8651 18.3009 10.7478 17.8567C10.2491 15.9695 10.2491 13.976 10.7478 12.0888C10.8651 11.6446 11.2147 11.3098 11.6477 11.2271L11.8885 11.181C12.1645 11.1283 12.4417 11.0844 12.7197 11.0493C12.9309 11.0227 13.1195 11.2381 13.1201 11.451V13.114C13.1201 13.5073 13.3341 13.6004 13.5968 13.3195C13.7178 13.1894 13.9023 13.1998 14.0085 13.3417L14.1576 13.5413C14.2771 13.6994 14.4705 13.6994 14.59 13.5413L14.7391 13.3417C14.8438 13.2013 15.0283 13.1909 15.1493 13.3195L15.1508 13.321C15.412 13.6019 15.6275 13.5087 15.6275 13.1155V11.451ZM16.8812 16.2856C17.0543 16.2856 17.1947 16.4325 17.1947 16.6138V17.2702C17.1947 17.4515 17.0543 17.5984 16.8812 17.5984C16.7081 17.5984 16.5678 17.4515 16.5678 17.2702V16.6138C16.5678 16.4325 16.7081 16.2856 16.8812 16.2856ZM16.2544 16.6138C16.2544 16.4325 16.114 16.2856 15.9409 16.2856C15.7678 16.2856 15.6275 16.4325 15.6275 16.6138V17.2702C15.6275 17.4515 15.7678 17.5984 15.9409 17.5984C16.114 17.5984 16.2544 17.4515 16.2544 17.2702V16.6138ZM15.0006 16.2856C15.1737 16.2856 15.3141 16.4325 15.3141 16.6138V17.2702C15.3141 17.4515 15.1737 17.5984 15.0006 17.5984C14.8275 17.5984 14.6872 17.4515 14.6872 17.2702V16.6138C14.6872 16.4325 14.8275 16.2856 15.0006 16.2856Z"
        attr.fill="url({{ '#paint1_linear_4042_12978' + unique }})"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.37378 5C2.37378 3.89543 3.26921 3 4.37378 3C4.37378 4.10457 5.26921 5 6.37378 5H12.3738C13.4783 5 14.3738 4.10457 14.3738 3C15.4783 3 16.3738 3.89543 16.3738 5V10.1412C15.508 10.0182 14.6344 9.9755 13.7632 10.0129C13.7181 10.0044 13.6714 10 13.6238 10H5.12378C4.70957 10 4.37378 10.3358 4.37378 10.75C4.37378 11.1642 4.70957 11.5 5.12378 11.5H9.92284C9.86411 11.6236 9.81643 11.7533 9.78093 11.8877C9.25271 13.8869 9.23846 15.9949 9.73819 18H4.37378C3.26921 18 2.37378 17.1046 2.37378 16V5ZM5.12378 7C4.70957 7 4.37378 7.33579 4.37378 7.75C4.37378 8.16421 4.70957 8.5 5.12378 8.5H13.6238C14.038 8.5 14.3738 8.16421 14.3738 7.75C14.3738 7.33579 14.038 7 13.6238 7H5.12378ZM5.12378 13C4.70957 13 4.37378 13.3358 4.37378 13.75C4.37378 14.1642 4.70957 14.5 5.12378 14.5H7.62378C8.03799 14.5 8.37378 14.1642 8.37378 13.75C8.37378 13.3358 8.03799 13 7.62378 13H5.12378Z"
        attr.fill="url({{ '#paint2_linear_4042_12978' + unique }})"
      />
      <defs>
        <linearGradient
          id="{{ 'paint0_linear_4042_12978' + unique }}"
          x1="10.3738"
          y1="2"
          x2="10.3738"
          y2="19"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="var(--gradient1)" />
          <stop offset="1" stop-color="var(--gradient2)" />
        </linearGradient>
        <linearGradient
          id="{{ 'paint1_linear_4042_12978' + unique }}"
          x1="10.3738"
          y1="2"
          x2="10.3738"
          y2="19"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="var(--gradient1)" />
          <stop offset="1" stop-color="var(--gradient2)" />
        </linearGradient>
        <linearGradient
          id="{{ 'paint2_linear_4042_12978' + unique }}"
          x1="10.3738"
          y1="2"
          x2="10.3738"
          y2="19"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="var(--gradient1)" />
          <stop offset="1" stop-color="var(--gradient2)" />
        </linearGradient>
      </defs>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.NAV_FINANCE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.8089 6.44336V3.48097C12.8089 2.63024 12.1065 1.99805 11.326 1.99805C11.1543 1.99805 10.9748 2.02927 10.8031 2.09171L4.60601 4.43316C3.73968 4.76096 3.16992 5.58828 3.16992 6.51705V9.37798V9.38143V10.7672C3.16992 11.0638 3.48212 11.2511 3.76309 11.1575C4.20016 11.0092 4.66065 10.9311 5.12113 10.9311C7.486 10.9311 9.4138 12.8589 9.4138 15.2238C9.4138 15.7858 9.26551 16.4023 9.03136 16.9487C8.90648 17.2297 9.1016 17.5653 9.40599 17.5653H15.0645C16.6801 17.5653 17.9991 16.2462 17.9991 14.6306V14.4823C17.9991 14.0531 17.6479 13.7019 17.2186 13.7019H16.5396C15.7904 13.7019 15.0723 13.2414 14.8772 12.5155C14.7211 11.9224 14.9084 11.3448 15.2987 10.9702C15.5874 10.6736 15.9855 10.5019 16.4225 10.5019H17.2186C17.6479 10.5019 17.9991 10.1507 17.9991 9.72139V9.37798C17.9991 7.76238 16.6801 6.44336 15.0645 6.44336H12.8089ZM11.6382 6.44336V3.48097C11.6382 3.27024 11.4509 3.16877 11.326 3.16877C11.287 3.16877 11.2479 3.17658 11.2089 3.19219L5.01967 5.52584C4.60601 5.68193 4.34065 6.07218 4.34065 6.51705V7.03653C4.83235 6.6619 5.44113 6.44336 6.10454 6.44336H11.6382ZM4.77817 18.3284C4.09383 18.2512 3.43157 17.9532 2.9128 17.4344C1.69313 16.2147 1.69313 14.239 2.9128 13.0193C3.32671 12.6054 3.83445 12.3294 4.36978 12.2025C4.68435 12.1197 5.00996 12.0921 5.32454 12.1197C6.05855 12.1584 6.77048 12.4619 7.32788 13.0193C8.13364 13.8251 8.40406 14.9564 8.14468 15.9774C8.01774 16.5127 7.7418 17.0205 7.32788 17.4344C6.63251 18.1298 5.68878 18.4333 4.77817 18.3284ZM5.1093 16.9818C5.4294 16.9818 5.6943 16.7169 5.6943 16.3968L5.6943 15.8118L6.30138 15.8118C6.62147 15.8118 6.88638 15.5469 6.88638 15.2268C6.88638 15.0613 6.82015 14.9178 6.71529 14.8129C6.61043 14.7081 6.46694 14.6418 6.30138 14.6418L5.6943 14.6418L5.6943 14.0568C5.68878 13.8968 5.62256 13.7533 5.5177 13.6484C5.41284 13.5436 5.26935 13.4774 5.1093 13.4718C4.78369 13.4774 4.5243 13.7367 4.51879 14.0624L4.5243 14.6418L3.9669 14.6363C3.64129 14.6418 3.3819 14.9012 3.37638 15.2268C3.3819 15.5525 3.64129 15.8118 3.9669 15.8174L4.5243 15.8118L4.51879 16.3913C4.5243 16.7169 4.78369 16.9763 5.1093 16.9818ZM17.9993 11.7164V12.4969C17.9993 12.7076 17.8354 12.8793 17.6169 12.8871H16.4774C16.0637 12.8871 15.6891 12.5828 15.6579 12.1769C15.6345 11.9349 15.7281 11.7086 15.8842 11.5525C16.0247 11.4042 16.2198 11.3262 16.4305 11.3262H17.6091C17.8354 11.334 17.9993 11.5057 17.9993 11.7164ZM8.24307 10.3458H12.1455C12.4655 10.3458 12.7309 10.0804 12.7309 9.76042C12.7309 9.44042 12.4655 9.17506 12.1455 9.17506H8.24307C7.92307 9.17506 7.65771 9.44042 7.65771 9.76042C7.65771 10.0804 7.92307 10.3458 8.24307 10.3458Z"
        attr.fill="url({{ '#paint0_linear_4042_13031' + unique }})"
      />
      <defs>
        <linearGradient
          id="{{ 'paint0_linear_4042_13031' + unique }}"
          x1="9.99868"
          y1="1.99805"
          x2="9.99868"
          y2="18.3487"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="var(--gradient1)" />
          <stop offset="1" stop-color="var(--gradient2)" />
        </linearGradient>
      </defs>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.NAV_HELP">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.38816 2.60611C7.38816 2.1628 6.9956 1.71364 6.55577 1.76906C5.9761 1.84209 5.39802 1.93363 4.82233 2.04367L4.32072 2.13955C3.41873 2.31196 2.69036 3.00939 2.44586 3.93476C1.40704 7.86641 1.40704 12.0196 2.44586 15.9513C2.69036 16.8766 3.41873 17.5741 4.32072 17.7465L4.82233 17.8424C6.75369 18.2115 8.71205 18.3724 10.6669 18.3251C9.8634 17.4843 9.32789 16.3851 9.19761 15.1649C9.07784 15.3165 8.89676 15.4132 8.69412 15.4132C8.33349 15.4132 8.04114 15.1071 8.04114 14.7294V13.3619C8.04114 12.9842 8.33349 12.6781 8.69412 12.6781C9.01334 12.6781 9.27906 12.918 9.33588 13.235C9.93512 10.8957 12.0573 9.16654 14.5834 9.16654C16.0333 9.16654 17.3502 9.73623 18.3224 10.664C18.3915 8.40329 18.1355 6.13435 17.5543 3.93476C17.3098 3.00939 16.5814 2.31196 15.6794 2.13955L15.1778 2.04367C14.6027 1.93374 14.0252 1.84227 13.4461 1.76927C13.0061 1.71381 12.6131 2.16259 12.612 2.60611V6.07075C12.612 6.88994 12.1662 7.08396 11.6189 6.49882C11.3667 6.22781 10.9824 6.24937 10.761 6.54502L10.4505 6.96077C10.2015 7.2903 9.79868 7.2903 9.54963 6.96077L9.2391 6.54502C9.0208 6.25245 8.63647 6.23089 8.38435 6.49882L8.38127 6.5019C7.83706 7.08704 7.38816 6.89302 7.38816 6.07383V2.60611ZM4.77624 12.6781C4.41561 12.6781 4.12326 12.9842 4.12326 13.3619V14.7294C4.12326 15.1071 4.41561 15.4132 4.77624 15.4132C5.13687 15.4132 5.42922 15.1071 5.42922 14.7294V13.3619C5.42922 12.9842 5.13687 12.6781 4.77624 12.6781ZM6.0822 13.3619C6.0822 12.9842 6.37455 12.6781 6.73518 12.6781C7.09581 12.6781 7.38816 12.9842 7.38816 13.3619V14.7294C7.38816 15.1071 7.09581 15.4132 6.73518 15.4132C6.37455 15.4132 6.0822 15.1071 6.0822 14.7294V13.3619ZM14.5834 18.3334C16.7263 18.3334 18.3334 16.7263 18.3334 14.5834C18.3334 12.4406 16.7263 10.8334 14.5834 10.8334C12.4406 10.8334 10.8334 12.5123 10.8334 14.5834C10.8334 16.6545 12.4406 18.3334 14.5834 18.3334ZM14.5835 12.4406C14.2877 12.4406 14.0478 12.6805 14.0478 12.9763V14.5835C14.0478 14.8793 14.2877 15.1192 14.5835 15.1192C14.8794 15.1192 15.1193 14.8793 15.1193 14.5835V12.9763C15.1193 12.6805 14.8794 12.4406 14.5835 12.4406ZM14.0478 16.1905C14.0478 15.8947 14.2877 15.6548 14.5835 15.6548C14.8794 15.6548 15.1193 15.8947 15.1193 16.1905C15.1193 16.4864 14.8794 16.7262 14.5835 16.7262C14.2877 16.7262 14.0478 16.4864 14.0478 16.1905Z"
        attr.fill="url({{ '#paint0_linear_4042_13071' + unique }})"
      />
      <defs>
        <linearGradient
          id="{{ 'paint0_linear_4042_13071' + unique }}"
          x1="10.0001"
          y1="1.7644"
          x2="10.0001"
          y2="18.3334"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="var(--gradient1)" />
          <stop offset="1" stop-color="var(--gradient2)" />
        </linearGradient>
      </defs>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.NAV_SETTING">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.6334 11.2473C16.9158 11.3973 17.1337 11.6342 17.2869 11.871C17.5855 12.3605 17.5613 12.9605 17.2708 13.4894L16.706 14.4368C16.4075 14.9421 15.8508 15.2579 15.278 15.2579C14.9956 15.2579 14.681 15.1789 14.4228 15.021C14.213 14.8868 13.971 14.8394 13.7128 14.8394C12.914 14.8394 12.2444 15.4947 12.2202 16.2763C12.2202 17.1842 11.4779 17.8947 10.5501 17.8947H9.45284C8.51694 17.8947 7.77467 17.1842 7.77467 16.2763C7.75854 15.4947 7.08889 14.8394 6.29015 14.8394C6.0239 14.8394 5.78186 14.8868 5.58015 15.021C5.32198 15.1789 4.99925 15.2579 4.72494 15.2579C4.14404 15.2579 3.58734 14.9421 3.28882 14.4368L2.73212 13.4894C2.4336 12.9763 2.41747 12.3605 2.71598 11.871C2.84507 11.6342 3.08712 11.3973 3.36143 11.2473C3.58734 11.1368 3.73256 10.9552 3.86972 10.7421C4.27313 10.0631 4.03108 9.17101 3.3453 8.76838C2.54655 8.31838 2.28838 7.31575 2.74826 6.53417L3.28882 5.60259C3.75677 4.82101 4.75721 4.5447 5.56402 5.00259C6.26594 5.38154 7.17764 5.12891 7.58911 4.45786C7.7182 4.2368 7.79081 3.99996 7.77467 3.76312C7.75854 3.45522 7.84729 3.16312 8.00058 2.92628C8.2991 2.4368 8.83966 2.12101 9.42863 2.10522H10.5662C11.1633 2.10522 11.7038 2.4368 12.0023 2.92628C12.1476 3.16312 12.2444 3.45522 12.2202 3.76312C12.2041 3.99996 12.2767 4.2368 12.4058 4.45786C12.8172 5.12891 13.7289 5.38154 14.4389 5.00259C15.2377 4.5447 16.2462 4.82101 16.706 5.60259L17.2466 6.53417C17.7146 7.31575 17.4564 8.31838 16.6496 8.76838C15.9638 9.17101 15.7217 10.0631 16.1332 10.7421C16.2623 10.9552 16.4075 11.1368 16.6334 11.2473ZM7.71875 10.0094C7.71875 11.2488 8.7434 12.2357 10.0101 12.2357C11.2768 12.2357 12.2772 11.2488 12.2772 10.0094C12.2772 8.76988 11.2768 7.77515 10.0101 7.77515C8.7434 7.77515 7.71875 8.76988 7.71875 10.0094Z"
        attr.fill="url({{ '#paint0_linear_4042_13112' + unique }})"
      />
      <defs>
        <linearGradient
          id="{{ 'paint0_linear_4042_13112' + unique }}"
          x1="10"
          y1="2.10522"
          x2="10"
          y2="17.8947"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="var(--gradient1)" />
          <stop offset="1" stop-color="var(--gradient2)" />
        </linearGradient>
      </defs>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.NAV_DARK_THEME">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12"
        cy="12"
        r="9"
        attr.stroke="url({{ '#paint0_linear_5547_112976' + unique }})"
        stroke-width="2"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15 6.80269C13.2066 7.84012 12 9.77915 12 12C12 14.2208 13.2066 16.1599 15 17.1973C14.1175 17.7078 13.0929 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C13.0929 6 14.1175 6.29218 15 6.80269Z"
        attr.fill="url(#{{ 'paint1_linear_5547_112976' + unique }})"
      />
      <defs>
        <linearGradient
          id="{{ 'paint0_linear_5547_112976' + unique }}"
          x1="12"
          y1="2"
          x2="12"
          y2="22"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="var(--gradient1)" />
          <stop offset="1" stop-color="var(--gradient2)" />
        </linearGradient>
        <linearGradient
          id="{{ 'paint1_linear_5547_112976' + unique }}"
          x1="10.5"
          y1="6"
          x2="10.5"
          y2="18"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="var(--gradient1)" />
          <stop offset="1" stop-color="var(--gradient2)" />
        </linearGradient>
      </defs>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.NAV_LIGHT_THEME">
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="7" cy="7" r="6.5" stroke="#E52138" stroke-dasharray="2 2" />
      <mask id="{{ 'path-2-inside-1_5577_126853' + unique }}" fill="white">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.9998 11.2003C9.3194 11.2003 11.1998 9.31989 11.1998 7.00029C11.1998 4.6807 9.3194 2.80029 6.9998 2.80029C4.68021 2.80029 2.7998 4.6807 2.7998 7.00029C2.7998 9.31989 4.68021 11.2003 6.9998 11.2003Z"
        />
      </mask>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.9998 11.2003C9.3194 11.2003 11.1998 9.31989 11.1998 7.00029C11.1998 4.6807 9.3194 2.80029 6.9998 2.80029C4.68021 2.80029 2.7998 4.6807 2.7998 7.00029C2.7998 9.31989 4.68021 11.2003 6.9998 11.2003Z"
        fill="#E52138"
      />
      <path
        d="M9.19981 7.00029C9.19981 8.21532 8.21483 9.20029 6.9998 9.20029V13.2003C10.424 13.2003 13.1998 10.4245 13.1998 7.00029H9.19981ZM6.9998 4.80029C8.21483 4.80029 9.19981 5.78527 9.19981 7.00029H13.1998C13.1998 3.57613 10.424 0.800293 6.9998 0.800293V4.80029ZM4.7998 7.00029C4.7998 5.78527 5.78478 4.80029 6.9998 4.80029V0.800293C3.57564 0.800293 0.799805 3.57613 0.799805 7.00029H4.7998ZM6.9998 9.20029C5.78478 9.20029 4.7998 8.21532 4.7998 7.00029H0.799805C0.799805 10.4245 3.57564 13.2003 6.9998 13.2003V9.20029Z"
        fill="#E52138"
        attr.mask="url(#{{ 'path-2-inside-1_5577_126853' + unique }})"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.NAV_MENU">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.4"
        x="4.5957"
        y="18.2861"
        width="10.6667"
        height="10.6667"
        rx="2"
        attr.fill="url({{ '#paint0_linear_5547_103876' + unique }})"
      />
      <rect
        opacity="0.4"
        x="17.5469"
        y="5.33301"
        width="10.6667"
        height="10.6667"
        rx="2"
        attr.fill="url({{ '#paint1_linear_5547_103876' + unique }})"
      />
      <rect
        opacity="0.4"
        x="4.5957"
        y="5.33301"
        width="10.6667"
        height="10.6667"
        rx="2"
        attr.fill="url({{ '#paint2_linear_5547_103876' + unique }})"
      />
      <rect
        x="17.5469"
        y="18.2861"
        width="10.6667"
        height="10.6667"
        rx="2"
        attr.fill="url({{ '#paint3_linear_5547_103876' + unique }})"
      />
      <defs>
        <linearGradient
          id="{{ 'paint0_linear_5547_103876' + unique }}"
          x1="9.92904"
          y1="18.2861"
          x2="9.92904"
          y2="28.9528"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="var(--gradient1)" />
          <stop offset="1" stop-color="var(--gradient2)" />
        </linearGradient>
        <linearGradient
          id="{{ 'paint1_linear_5547_103876' + unique }}"
          x1="22.8802"
          y1="5.33301"
          x2="22.8802"
          y2="15.9997"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="var(--gradient1)" />
          <stop offset="1" stop-color="var(--gradient2)" />
        </linearGradient>
        <linearGradient
          id="{{ 'paint2_linear_5547_103876' + unique }}"
          x1="9.92904"
          y1="5.33301"
          x2="9.92904"
          y2="15.9997"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="var(--gradient1)" />
          <stop offset="1" stop-color="var(--gradient2)" />
        </linearGradient>
        <linearGradient
          id="{{ 'paint3_linear_5547_103876' + unique }}"
          x1="22.8802"
          y1="18.2861"
          x2="22.8802"
          y2="28.9528"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="var(--gradient1)" />
          <stop offset="1" stop-color="var(--gradient2)" />
        </linearGradient>
      </defs>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.NAV_CHAT">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.25 6.66667C17.4006 6.66667 18.3333 5.73393 18.3333 4.58333C18.3333 3.43274 17.4006 2.5 16.25 2.5C15.0994 2.5 14.1666 3.43274 14.1666 4.58333C14.1666 5.73393 15.0994 6.66667 16.25 6.66667Z"
        fill="var(--gradient2)"
      />
      <path
        d="M16.25 6.66667C17.4006 6.66667 18.3333 5.73393 18.3333 4.58333C18.3333 3.43274 17.4006 2.5 16.25 2.5C15.0994 2.5 14.1666 3.43274 14.1666 4.58333C14.1666 5.73393 15.0994 6.66667 16.25 6.66667Z"
        fill="var(--gradient2)"
      />
      <path
        d="M17.2666 7.75817C16.6833 7.9415 16.0416 7.97484 15.375 7.80817C14.2583 7.5165 13.35 6.62484 13.0416 5.50817C12.8916 4.9665 12.8833 4.43317 12.975 3.94984C13.0833 3.4165 12.7083 2.9165 12.175 2.9165H5.83329C3.33329 2.9165 1.66663 4.1665 1.66663 7.08317V12.9165C1.66663 15.8332 3.33329 17.0832 5.83329 17.0832H14.1666C16.6666 17.0832 18.3333 15.8332 18.3333 12.9165V8.54984C18.3333 7.99984 17.8 7.58317 17.2666 7.75817ZM12.9333 9.2915L11.95 10.0748C11.4 10.5165 10.7 10.7332 9.99996 10.7332C9.29996 10.7332 8.59163 10.5165 8.04996 10.0748L5.44163 7.9915C5.17496 7.77484 5.13329 7.37484 5.34163 7.10817C5.55829 6.8415 5.94996 6.7915 6.21663 7.00817L8.82496 9.0915C9.45829 9.59984 10.5333 9.59984 11.1666 9.0915L12.15 8.30817C12.4166 8.0915 12.8166 8.13317 13.025 8.40817C13.2416 8.67484 13.2 9.07484 12.9333 9.2915Z"
        fill="var(--gradient2)"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.GOOGLE">
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1896_15359)">
        <path
          d="M24.266 12.2765C24.266 11.4608 24.1999 10.6406 24.0588 9.83813H12.74V14.4591H19.2217C18.9528 15.9495 18.0885 17.2679 16.823 18.1056V21.104H20.69C22.9608 19.014 24.266 15.9274 24.266 12.2765Z"
          fill="#4285F4"
        />
        <path
          d="M12.74 24.0008C15.9764 24.0008 18.7058 22.9382 20.6944 21.1039L16.8274 18.1055C15.7516 18.8375 14.3626 19.252 12.7444 19.252C9.61376 19.252 6.95934 17.1399 6.00693 14.3003H2.01648V17.3912C4.05359 21.4434 8.20278 24.0008 12.74 24.0008Z"
          fill="#34A853"
        />
        <path
          d="M6.00253 14.3002C5.49987 12.8099 5.49987 11.196 6.00253 9.70569V6.61475H2.01649C0.31449 10.0055 0.31449 14.0004 2.01649 17.3912L6.00253 14.3002Z"
          fill="#FBBC04"
        />
        <path
          d="M12.74 4.74966C14.4508 4.7232 16.1043 5.36697 17.3433 6.54867L20.7694 3.12262C18.6 1.0855 15.7207 -0.034466 12.74 0.000808666C8.20277 0.000808666 4.05359 2.55822 2.01648 6.61481L6.00252 9.70575C6.95052 6.86173 9.60935 4.74966 12.74 4.74966Z"
          fill="#EA4335"
        />
      </g>
      <defs>
        <clipPath id="clip0_1896_15359">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.FACEBOOK">
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1896_1749)">
        <path
          d="M24.75 12C24.75 5.37258 19.3774 0 12.75 0C6.12258 0 0.75 5.37258 0.75 12C0.75 17.9895 5.1382 22.954 10.875 23.8542V15.4688H7.82812V12H10.875V9.35625C10.875 6.34875 12.6666 4.6875 15.4076 4.6875C16.7201 4.6875 18.0938 4.92188 18.0938 4.92188V7.875H16.5806C15.09 7.875 14.625 8.80008 14.625 9.75V12H17.9531L17.4211 15.4688H14.625V23.8542C20.3618 22.954 24.75 17.9895 24.75 12Z"
          fill="#1877F2"
        />
        <path
          d="M17.4211 15.4688L17.9531 12H14.625V9.75C14.625 8.80102 15.09 7.875 16.5806 7.875H18.0938V4.92188C18.0938 4.92188 16.7205 4.6875 15.4076 4.6875C12.6666 4.6875 10.875 6.34875 10.875 9.35625V12H7.82812V15.4688H10.875V23.8542C12.1174 24.0486 13.3826 24.0486 14.625 23.8542V15.4688H17.4211Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1896_1749">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.75)"
          />
        </clipPath>
      </defs>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.APPLE">
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.0926 17.1449C20.7599 17.9135 20.3661 18.6211 19.9098 19.2715C19.2878 20.1583 18.7786 20.7721 18.3861 21.113C17.7777 21.6724 17.1259 21.959 16.4279 21.9753C15.9268 21.9753 15.3225 21.8327 14.6191 21.5434C13.9133 21.2555 13.2648 21.113 12.6717 21.113C12.0498 21.113 11.3827 21.2555 10.6693 21.5434C9.95469 21.8327 9.37904 21.9834 8.93892 21.9984C8.26957 22.0269 7.60239 21.7322 6.93644 21.113C6.51139 20.7422 5.97974 20.1067 5.34285 19.2063C4.65951 18.2449 4.09772 17.13 3.6576 15.8589C3.18624 14.486 2.94995 13.1565 2.94995 11.8694C2.94995 10.3951 3.26853 9.12345 3.90665 8.05784C4.40815 7.20191 5.07533 6.52672 5.91035 6.03105C6.74537 5.53539 7.64761 5.2828 8.61925 5.26664C9.1509 5.26664 9.84809 5.43109 10.7145 5.75429C11.5784 6.07858 12.1332 6.24303 12.3764 6.24303C12.5582 6.24303 13.1745 6.05074 14.2192 5.66738C15.2071 5.31186 16.0409 5.16466 16.724 5.22264C18.5749 5.37202 19.9655 6.10167 20.8902 7.41619C19.2349 8.4192 18.416 9.82403 18.4323 11.6262C18.4472 13.03 18.9565 14.1981 19.9573 15.1256C20.4109 15.5561 20.9174 15.8888 21.481 16.1251C21.3587 16.4795 21.2297 16.819 21.0926 17.1449ZM16.8475 0.440369C16.8475 1.54062 16.4456 2.56792 15.6444 3.51878C14.6775 4.64917 13.508 5.30236 12.2398 5.19929C12.2236 5.06729 12.2142 4.92837 12.2142 4.78239C12.2142 3.72615 12.674 2.59576 13.4906 1.67152C13.8983 1.20356 14.4167 0.814453 15.0455 0.504058C15.6729 0.198295 16.2663 0.0292007 16.8244 0.000244141C16.8407 0.147331 16.8475 0.294426 16.8475 0.440355V0.440369Z"
        fill="black"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.RELOAD_OUTLINE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 16H19V21M10 8H5V3M19.4176 9.00316C18.8569 7.61542 17.9181 6.41279 16.708 5.53198C15.4979 4.65117 14.0652 4.12752 12.5723 4.02051C11.0794 3.9135 9.58606 4.2274 8.2627 4.92661C6.93933 5.62582 5.83882 6.68228 5.08594 7.97587M4.58203 14.9968C5.14272 16.3846 6.08146 17.5872 7.29157 18.468C8.50169 19.3488 9.93504 19.8725 11.4279 19.9795C12.9208 20.0865 14.4136 19.7726 15.737 19.0734C17.0603 18.3742 18.1604 17.3178 18.9133 16.0242"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.TICK_CIRCLE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.00008 0.166504C2.78591 0.166504 0.166748 2.78567 0.166748 5.99984C0.166748 9.214 2.78591 11.8332 6.00008 11.8332C9.21425 11.8332 11.8334 9.214 11.8334 5.99984C11.8334 2.78567 9.21425 0.166504 6.00008 0.166504ZM8.78841 4.65817L5.48091 7.96567C5.39925 8.04734 5.28841 8.094 5.17175 8.094C5.05508 8.094 4.94425 8.04734 4.86258 7.96567L3.21175 6.31484C3.04258 6.14567 3.04258 5.86567 3.21175 5.6965C3.38091 5.52734 3.66091 5.52734 3.83008 5.6965L5.17175 7.03817L8.17008 4.03984C8.33925 3.87067 8.61925 3.87067 8.78841 4.03984C8.95758 4.209 8.95758 4.48317 8.78841 4.65817Z"
        fill="currentColor"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.CLOSE_CIRCLE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00016 1.33325C4.32683 1.33325 1.3335 4.32659 1.3335 7.99992C1.3335 11.6733 4.32683 14.6666 8.00016 14.6666C11.6735 14.6666 14.6668 11.6733 14.6668 7.99992C14.6668 4.32659 11.6735 1.33325 8.00016 1.33325ZM10.2402 9.53325C10.4335 9.72659 10.4335 10.0466 10.2402 10.2399C10.1402 10.3399 10.0135 10.3866 9.88683 10.3866C9.76016 10.3866 9.6335 10.3399 9.5335 10.2399L8.00016 8.70659L6.46683 10.2399C6.36683 10.3399 6.24016 10.3866 6.1135 10.3866C5.98683 10.3866 5.86016 10.3399 5.76016 10.2399C5.56683 10.0466 5.56683 9.72659 5.76016 9.53325L7.2935 7.99992L5.76016 6.46659C5.56683 6.27325 5.56683 5.95325 5.76016 5.75992C5.9535 5.56659 6.2735 5.56659 6.46683 5.75992L8.00016 7.29325L9.5335 5.75992C9.72683 5.56659 10.0468 5.56659 10.2402 5.75992C10.4335 5.95325 10.4335 6.27325 10.2402 6.46659L8.70683 7.99992L10.2402 9.53325Z"
        fill="currentColor"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.TIME_OUTLINE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.2913 11.0417C17.2913 15.0667 14.0247 18.3333 9.99967 18.3333C5.97467 18.3333 2.70801 15.0667 2.70801 11.0417C2.70801 7.01667 5.97467 3.75 9.99967 3.75C14.0247 3.75 17.2913 7.01667 17.2913 11.0417Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 6.66675V10.8334"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.5 1.66675H12.5"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.DANGER_OUTLINE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 7.5V11.6667"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.99986 17.8417H4.94986C2.0582 17.8417 0.849863 15.775 2.24986 13.25L4.84986 8.56665L7.29986 4.16665C8.7832 1.49165 11.2165 1.49165 12.6999 4.16665L15.1499 8.57498L17.7499 13.2583C19.1499 15.7833 17.9332 17.85 15.0499 17.85H9.99986V17.8417Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.99512 14.1667H10.0026"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.ORDER_SEARCH_OUTLINE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.6416 6.2002L9.99992 10.4585L17.3082 6.22517"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 18.0085V10.4502"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.0079 10.6918V7.64175C18.0079 6.49175 17.1829 5.09177 16.1745 4.53343L11.7245 2.06675C10.7745 1.53341 9.22453 1.53341 8.27453 2.06675L3.82453 4.53343C2.8162 5.09177 1.99121 6.49175 1.99121 7.64175V12.3584C1.99121 13.5084 2.8162 14.9084 3.82453 15.4668L8.27453 17.9334C8.74953 18.2001 9.37453 18.3334 9.99953 18.3334C10.6245 18.3334 11.2495 18.2001 11.7245 17.9334"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.9997 17.8334C17.4724 17.8334 18.6663 16.6394 18.6663 15.1667C18.6663 13.6939 17.4724 12.5 15.9997 12.5C14.5269 12.5 13.333 13.6939 13.333 15.1667C13.333 16.6394 14.5269 17.8334 15.9997 17.8334Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.1663 18.3333L18.333 17.5"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.SCAN_OUTLINE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.02276 2.5C7.37276 2.5 7.65692 2.77865 7.65692 3.12268C7.65692 3.46589 7.37359 3.74455 7.02276 3.74455L5.66526 3.74536C4.53859 3.747 3.62192 4.6467 3.62192 5.75233V7.30167C3.62192 7.64488 3.33692 7.92436 2.98692 7.92436C2.63692 7.92436 2.35276 7.64488 2.35276 7.30167V5.75233C2.35276 3.96109 3.83859 2.50245 5.66442 2.50082L7.02192 2.5H7.02276ZM13.0002 2.50025H14.3277C16.1585 2.50025 17.6468 3.95971 17.6468 5.75502V7.30192C17.6468 7.64513 17.3635 7.9246 17.0127 7.9246C16.6627 7.9246 16.3785 7.64513 16.3785 7.30192V5.75502C16.3785 4.64613 15.4585 3.74397 14.3277 3.74397H13.0002C12.6502 3.74397 12.366 3.46614 12.366 3.12293C12.366 2.7789 12.6502 2.50025 13.0002 2.50025ZM12.3018 5.61888H7.69842C6.64509 5.6295 5.79842 6.47364 5.80759 7.50735V8.54516C5.81009 8.6661 5.90926 8.76497 6.03259 8.76906H13.9659C14.0901 8.76579 14.1893 8.66691 14.1934 8.54516V7.50735C14.1943 7.00807 13.9976 6.52839 13.6426 6.17129C13.2901 5.81745 12.8059 5.61888 12.3018 5.61888ZM1.46801 10.0344H18.5322C18.8822 10.0344 19.1663 10.313 19.1663 10.657C19.1663 11.0003 18.8822 11.2781 18.5322 11.2781H17.6472V14.2444C17.6472 16.0405 16.158 17.5 14.328 17.5H13.0005C12.6497 17.5 12.3655 17.2213 12.3655 16.8773C12.3655 16.5341 12.6497 16.2555 13.0005 16.2555H14.328C15.4588 16.2555 16.3788 15.3541 16.3788 14.2444V11.2781H14.193V12.1042C14.2013 13.138 13.3555 13.9829 12.3013 13.9927H7.69801C6.64467 13.9829 5.79884 13.138 5.80717 12.1042V11.2781H3.62134V14.2477C3.62134 15.3533 4.53884 16.253 5.66634 16.2546L7.02301 16.2555C7.37301 16.2555 7.65717 16.5341 7.65717 16.8773C7.65634 17.2213 7.37301 17.5 7.02217 17.5L5.66467 17.4992C3.83884 17.4975 2.35217 16.0389 2.35217 14.2477V11.2781H1.46801C1.11801 11.2781 0.833008 11.0003 0.833008 10.657C0.833008 10.313 1.11801 10.0344 1.46801 10.0344Z"
        fill="currentColor"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.ENTER_OUTLINE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.38978 11.5002H13.0005C14.5005 11.5002 15.0312 10.4999 15.0312 8.99994L15.0312 5.5"
        stroke="currentColor"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.12988 14.5002L4.96988 11.3402L8.12988 8.18018"
        stroke="currentColor"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.CLOSE_CIRCLE_OUTLINE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00065 14.6666C11.6673 14.6666 14.6673 11.6666 14.6673 7.99998C14.6673 4.33331 11.6673 1.33331 8.00065 1.33331C4.33398 1.33331 1.33398 4.33331 1.33398 7.99998C1.33398 11.6666 4.33398 14.6666 8.00065 14.6666Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.11328 9.88668L9.88661 6.11334"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.88661 9.88668L6.11328 6.11334"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.TICK_CIRCLE_OUTLINE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00065 14.6666C11.6673 14.6666 14.6673 11.6666 14.6673 7.99998C14.6673 4.33331 11.6673 1.33331 8.00065 1.33331C4.33398 1.33331 1.33398 4.33331 1.33398 7.99998C1.33398 11.6666 4.33398 14.6666 8.00065 14.6666Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.16602 8.00001L7.05268 9.88668L10.8327 6.11334"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.DOC_DOWNLOAD_OUTLINE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 9.16666V14.1667L9.16667 12.5"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.49967 14.1667L5.83301 12.5"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.3337 8.33332V12.5C18.3337 16.6667 16.667 18.3333 12.5003 18.3333H7.50033C3.33366 18.3333 1.66699 16.6667 1.66699 12.5V7.49999C1.66699 3.33332 3.33366 1.66666 7.50033 1.66666H11.667"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.3337 8.33332H15.0003C12.5003 8.33332 11.667 7.49999 11.667 4.99999V1.66666L18.3337 8.33332Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.ELLIPSIS_HORIZONTAL_OUTLINE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 10C3.9 10 3 10.9 3 12C3 13.1 3.9 14 5 14C6.1 14 7 13.1 7 12C7 10.9 6.1 10 5 10Z"
        stroke="currentColor"
        stroke-width="1.5"
      />
      <path
        d="M19 10C17.9 10 17 10.9 17 12C17 13.1 17.9 14 19 14C20.1 14 21 13.1 21 12C21 10.9 20.1 10 19 10Z"
        stroke="currentColor"
        stroke-width="1.5"
      />
      <path
        d="M12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
        stroke="currentColor"
        stroke-width="1.5"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.ADD_SQUARE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.794 1.33337H5.20732C2.78065 1.33337 1.33398 2.78004 1.33398 5.20671V10.7867C1.33398 13.22 2.78065 14.6667 5.20732 14.6667H10.7873C13.214 14.6667 14.6607 13.22 14.6607 10.7934V5.20671C14.6673 2.78004 13.2207 1.33337 10.794 1.33337ZM10.6673 8.50004H8.50065V10.6667C8.50065 10.94 8.27398 11.1667 8.00065 11.1667C7.72732 11.1667 7.50065 10.94 7.50065 10.6667V8.50004H5.33398C5.06065 8.50004 4.83398 8.27337 4.83398 8.00004C4.83398 7.72671 5.06065 7.50004 5.33398 7.50004H7.50065V5.33337C7.50065 5.06004 7.72732 4.83337 8.00065 4.83337C8.27398 4.83337 8.50065 5.06004 8.50065 5.33337V7.50004H10.6673C10.9407 7.50004 11.1673 7.72671 11.1673 8.00004C11.1673 8.27337 10.9407 8.50004 10.6673 8.50004Z"
        fill="currentColor"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.ADD_SQUARE_OUTLINE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33398 8H10.6673"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 10.6668V5.3335"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.00065 14.6668H10.0007C13.334 14.6668 14.6673 13.3335 14.6673 10.0002V6.00016C14.6673 2.66683 13.334 1.3335 10.0007 1.3335H6.00065C2.66732 1.3335 1.33398 2.66683 1.33398 6.00016V10.0002C1.33398 13.3335 2.66732 14.6668 6.00065 14.6668Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.DELIVERY_OUTLINE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00049 9.33337H8.66716C9.40049 9.33337 10.0005 8.73337 10.0005 8.00004V1.33337H4.00049C3.00049 1.33337 2.12716 1.8867 1.67383 2.70003"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.33398 11.3334C1.33398 12.44 2.22732 13.3334 3.33398 13.3334H4.00065C4.00065 12.6 4.60065 12 5.33398 12C6.06732 12 6.66732 12.6 6.66732 13.3334H9.33398C9.33398 12.6 9.93398 12 10.6673 12C11.4007 12 12.0007 12.6 12.0007 13.3334H12.6673C13.774 13.3334 14.6673 12.44 14.6673 11.3334V9.33337H12.6673C12.3007 9.33337 12.0007 9.03337 12.0007 8.66671V6.66671C12.0007 6.30004 12.3007 6.00004 12.6673 6.00004H13.5273L12.3873 4.00671C12.1473 3.59338 11.7073 3.33337 11.2273 3.33337H10.0007V8.00004C10.0007 8.73337 9.40065 9.33337 8.66732 9.33337H8.00065"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.33333 14.6667C6.06971 14.6667 6.66667 14.0697 6.66667 13.3333C6.66667 12.597 6.06971 12 5.33333 12C4.59695 12 4 12.597 4 13.3333C4 14.0697 4.59695 14.6667 5.33333 14.6667Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.6673 14.6667C11.4037 14.6667 12.0007 14.0697 12.0007 13.3333C12.0007 12.597 11.4037 12 10.6673 12C9.93094 12 9.33398 12.597 9.33398 13.3333C9.33398 14.0697 9.93094 14.6667 10.6673 14.6667Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.6667 8V9.33333H12.6667C12.3 9.33333 12 9.03333 12 8.66667V6.66667C12 6.3 12.3 6 12.6667 6H13.5267L14.6667 8Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.33398 5.33337H5.33398"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.33398 7.33337H4.00065"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.33398 9.33337H2.66732"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.WARNING_HEXA_FILL">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3806 3.91246L7.91562 1.91163C7.34979 1.58496 6.64979 1.58496 6.07812 1.91163L2.61896 3.91246C2.05312 4.23913 1.70312 4.84579 1.70312 5.50496V9.49496C1.70312 10.1483 2.05312 10.755 2.61896 11.0875L6.08396 13.0883C6.64979 13.415 7.34979 13.415 7.92146 13.0883L11.3865 11.0875C11.9523 10.7608 12.3023 10.1541 12.3023 9.49496V5.50496C12.2965 4.84579 11.9465 4.24496 11.3806 3.91246ZM6.56229 5.02079C6.56229 4.78163 6.76062 4.58329 6.99979 4.58329C7.23896 4.58329 7.43729 4.78163 7.43729 5.02079V8.08329C7.43729 8.32246 7.23896 8.52079 6.99979 8.52079C6.76062 8.52079 6.56229 8.32246 6.56229 8.08329V5.02079ZM7.53646 10.2008C7.50729 10.2708 7.46646 10.335 7.41396 10.3933C7.30312 10.5041 7.15729 10.5625 6.99979 10.5625C6.92396 10.5625 6.84812 10.545 6.77812 10.5158C6.70229 10.4866 6.64396 10.4458 6.58562 10.3933C6.53312 10.335 6.49229 10.2708 6.45729 10.2008C6.42812 10.1308 6.41646 10.055 6.41646 9.97913C6.41646 9.82746 6.47479 9.67579 6.58562 9.56496C6.64396 9.51246 6.70229 9.47163 6.77812 9.44246C6.99396 9.34913 7.25062 9.40163 7.41396 9.56496C7.46646 9.62329 7.50729 9.68163 7.53646 9.75746C7.56562 9.82746 7.58312 9.90329 7.58312 9.97913C7.58312 10.055 7.56562 10.1308 7.53646 10.2008Z"
        fill="currentColor"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.GALLERY_OUTLINE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.50448 11.0892L1.49281 11.1009C1.33531 10.7567 1.23615 10.3659 1.19531 9.9342C1.23615 10.36 1.34698 10.745 1.50448 11.0892Z"
        fill="currentColor"
      />
      <path
        d="M5.24966 6.05499C6.01642 6.05499 6.63799 5.43341 6.63799 4.66665C6.63799 3.8999 6.01642 3.27832 5.24966 3.27832C4.48291 3.27832 3.86133 3.8999 3.86133 4.66665C3.86133 5.43341 4.48291 6.05499 5.24966 6.05499Z"
        fill="currentColor"
      />
      <path
        d="M9.44352 1.16663H4.55518C2.43185 1.16663 1.16602 2.43246 1.16602 4.55579V9.44413C1.16602 10.08 1.27685 10.6341 1.49268 11.1008C1.99435 12.2091 3.06768 12.8333 4.55518 12.8333H9.44352C11.5668 12.8333 12.8327 11.5675 12.8327 9.44413V8.10829V4.55579C12.8327 2.43246 11.5668 1.16663 9.44352 1.16663ZM11.8818 7.29163C11.4268 6.90079 10.6918 6.90079 10.2368 7.29163L7.81018 9.37413C7.35518 9.76496 6.62018 9.76496 6.16518 9.37413L5.96685 9.21079C5.55268 8.84913 4.89352 8.81413 4.42685 9.12913L2.24518 10.5933C2.11685 10.2666 2.04102 9.88746 2.04102 9.44413V4.55579C2.04102 2.91079 2.91018 2.04163 4.55518 2.04163H9.44352C11.0885 2.04163 11.9577 2.91079 11.9577 4.55579V7.35579L11.8818 7.29163Z"
        fill="currentColor"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.CALENDAR_EDIT_OUTLINE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.334 1.66663V4.16663"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.91602 7.57495H17.0827"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.0085 13.1417L13.0585 16.0917C12.9419 16.2084 12.8335 16.425 12.8085 16.5834L12.6502 17.7084C12.5919 18.1167 12.8752 18.4 13.2835 18.3417L14.4085 18.1834C14.5669 18.1584 14.7919 18.05 14.9002 17.9334L17.8502 14.9834C18.3585 14.475 18.6002 13.8834 17.8502 13.1334C17.1085 12.3917 16.5169 12.6334 16.0085 13.1417Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.584 13.5667C15.834 14.4667 16.534 15.1667 17.434 15.4167"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 18.3333H6.66667C3.75 18.3333 2.5 16.6666 2.5 14.1666V7.08329C2.5 4.58329 3.75 2.91663 6.66667 2.91663H13.3333C16.25 2.91663 17.5 4.58329 17.5 7.08329V9.99996"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.99607 11.4167H10.0036"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.91209 11.4167H6.91957"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.91209 13.9167H6.91957"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.DELIVERY_BOX_OUTLINE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.11328 4.95996L7.99994 8.36662L13.8466 4.97994"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 14.4065V8.35986"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.6204 1.6535L3.0604 3.63352C2.25374 4.08018 1.59375 5.20017 1.59375 6.12017V9.88685C1.59375 10.8069 2.25374 11.9268 3.0604 12.3735L6.6204 14.3535C7.3804 14.7735 8.62706 14.7735 9.38706 14.3535L12.9471 12.3735C13.7537 11.9268 14.4137 10.8069 14.4137 9.88685V6.12017C14.4137 5.20017 13.7537 4.08018 12.9471 3.63352L9.38706 1.6535C8.6204 1.22683 7.3804 1.22683 6.6204 1.6535Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.3325 8.82674V6.38676L5.00586 2.7334"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.MINUS_CIRCLE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.93343 18.3337C14.5168 18.3337 18.2668 14.5837 18.2668 10.0003C18.2668 5.41699 14.5168 1.66699 9.93343 1.66699C5.3501 1.66699 1.6001 5.41699 1.6001 10.0003C1.6001 14.5837 5.3501 18.3337 9.93343 18.3337Z"
        fill="currentColor"
      />
      <path
        d="M6.6001 10H13.2668"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.ADD_CIRCLE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0001 18.3337C14.5834 18.3337 18.3334 14.5837 18.3334 10.0003C18.3334 5.41699 14.5834 1.66699 10.0001 1.66699C5.41675 1.66699 1.66675 5.41699 1.66675 10.0003C1.66675 14.5837 5.41675 18.3337 10.0001 18.3337Z"
        fill="currentColor"
      />
      <path
        d="M6.66675 10H13.3334"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 13.3337V6.66699"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.HELP_CIRCLE_OUTLINE">
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3121_116181)">
        <path
          d="M8.00016 14.6663C11.6821 14.6663 14.6668 11.6816 14.6668 7.99967C14.6668 4.31778 11.6821 1.33301 8.00016 1.33301C4.31826 1.33301 1.3335 4.31778 1.3335 7.99967C1.3335 11.6816 4.31826 14.6663 8.00016 14.6663Z"
          stroke="#636363"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8 11.333H8.00667"
          stroke="#636363"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.06006 6.00038C6.21679 5.55483 6.52616 5.17912 6.93336 4.9398C7.34056 4.70049 7.81932 4.61301 8.28484 4.69285C8.75036 4.7727 9.1726 5.01473 9.47678 5.37607C9.78095 5.7374 9.94743 6.19473 9.94672 6.66705C9.94672 8.00038 7.94673 8.66705 7.94673 8.66705"
          stroke="#636363"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.MAIL_OUTLINE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.167 17.0834H5.83366C3.33366 17.0834 1.66699 15.8334 1.66699 12.9167V7.08335C1.66699 4.16669 3.33366 2.91669 5.83366 2.91669H14.167C16.667 2.91669 18.3337 4.16669 18.3337 7.08335V12.9167C18.3337 15.8334 16.667 17.0834 14.167 17.0834Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.1663 7.5L11.558 9.58333C10.6997 10.2667 9.29134 10.2667 8.433 9.58333L5.83301 7.5"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.CHAT_DOT_OUTLINE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.58366 15.8334H7.16699C3.83366 15.8334 2.16699 15 2.16699 10.8334V6.66669C2.16699 3.33335 3.83366 1.66669 7.16699 1.66669H13.8337C17.167 1.66669 18.8337 3.33335 18.8337 6.66669V10.8334C18.8337 14.1667 17.167 15.8334 13.8337 15.8334H13.417C13.1587 15.8334 12.9087 15.9584 12.7503 16.1667L11.5003 17.8334C10.9503 18.5667 10.0503 18.5667 9.50033 17.8334L8.25033 16.1667C8.11699 15.9834 7.80866 15.8334 7.58366 15.8334Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.8301 9.16667H13.8375"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.4961 9.16667H10.5036"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.16209 9.16667H7.16957"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.CHAT_OUTLINE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.33333 11C8.78105 11 8.33333 11.4478 8.33333 12C8.33333 12.5523 8.78105 13 9.33333 13V11ZM22.6667 13C23.219 13 23.6667 12.5523 23.6667 12C23.6667 11.4478 23.219 11 22.6667 11V13ZM9.33333 16.3334C8.78105 16.3334 8.33333 16.7811 8.33333 17.3334C8.33333 17.8857 8.78105 18.3334 9.33333 18.3334V16.3334ZM16 18.3334C16.5523 18.3334 17 17.8857 17 17.3334C17 16.7811 16.5523 16.3334 16 16.3334V18.3334ZM28 26.6667L27.5528 27.5611C27.8628 27.7161 28.2309 27.6996 28.5257 27.5174C28.8205 27.3351 29 27.0133 29 26.6667H28ZM22.4069 24.0258L22.5455 23.0355L22.4069 24.0258ZM23.5676 24.4505L23.1203 25.3449L23.5676 24.4505ZM22.8875 24.1393L22.5686 25.087L22.8875 24.1393ZM4.43597 21.816L3.54497 22.27L4.43597 21.816ZM6.18404 23.5641L5.73005 24.4551L6.18404 23.5641ZM25.816 5.76935L26.27 4.87834L25.816 5.76935ZM27.564 7.51741L28.455 7.06342L27.564 7.51741ZM6.18404 5.76935L5.73005 4.87834L6.18404 5.76935ZM4.43597 7.51741L3.54497 7.06342L4.43597 7.51741ZM9.33333 13H22.6667V11H9.33333V13ZM9.33333 18.3334H16V16.3334H9.33333V18.3334ZM10.4 6.33337H21.6V4.33337H10.4V6.33337ZM5 17.6V11.7334H3V17.6H5ZM21.6594 23H10.4V25H21.6594V23ZM28.4472 25.7723L24.0148 23.5561L23.1203 25.3449L27.5528 27.5611L28.4472 25.7723ZM21.6594 25C22.0618 25 22.169 25.0022 22.2682 25.0161L22.5455 23.0355C22.2768 22.9978 22.0084 23 21.6594 23V25ZM24.0148 23.5561C23.7027 23.4 23.4636 23.278 23.2064 23.1915L22.5686 25.087C22.6636 25.119 22.7605 25.165 23.1203 25.3449L24.0148 23.5561ZM22.2682 25.0161C22.3703 25.0304 22.4709 25.0542 22.5686 25.087L23.2064 23.1915C22.9914 23.1191 22.7702 23.0669 22.5455 23.0355L22.2682 25.0161ZM3 17.6C3 18.7036 2.99922 19.5915 3.05782 20.3087C3.11737 21.0375 3.24318 21.6777 3.54497 22.27L5.32698 21.362C5.19279 21.0987 5.10062 20.751 5.05118 20.1458C5.00078 19.529 5 18.7366 5 17.6H3ZM10.4 23C9.26339 23 8.47108 22.9993 7.85424 22.9489C7.24907 22.8994 6.90138 22.8072 6.63803 22.6731L5.73005 24.4551C6.32234 24.7569 6.96253 24.8827 7.69138 24.9422C8.40855 25.0008 9.2964 25 10.4 25V23ZM3.54497 22.27C4.02433 23.2108 4.78924 23.9757 5.73005 24.4551L6.63803 22.6731C6.07354 22.3854 5.6146 21.9265 5.32698 21.362L3.54497 22.27ZM21.6 6.33337C22.7366 6.33337 23.5289 6.33415 24.1458 6.38455C24.7509 6.43399 25.0986 6.52617 25.362 6.66035L26.27 4.87834C25.6777 4.57655 25.0375 4.45074 24.3086 4.39119C23.5914 4.3326 22.7036 4.33337 21.6 4.33337V6.33337ZM29 11.7334C29 10.6298 29.0008 9.74193 28.9422 9.02475C28.8826 8.2959 28.7568 7.65571 28.455 7.06342L26.673 7.9714C26.8072 8.23476 26.8994 8.58245 26.9488 9.18761C26.9992 9.80446 27 10.5968 27 11.7334H29ZM25.362 6.66035C25.9265 6.94797 26.3854 7.40692 26.673 7.9714L28.455 7.06342C27.9757 6.12261 27.2108 5.35771 26.27 4.87834L25.362 6.66035ZM10.4 4.33337C9.2964 4.33337 8.40855 4.3326 7.69138 4.39119C6.96253 4.45074 6.32234 4.57655 5.73005 4.87834L6.63803 6.66035C6.90138 6.52617 7.24907 6.43399 7.85424 6.38455C8.47108 6.33415 9.26339 6.33337 10.4 6.33337V4.33337ZM5 11.7334C5 10.5968 5.00078 9.80446 5.05118 9.18761C5.10062 8.58245 5.19279 8.23476 5.32698 7.9714L3.54497 7.06342C3.24318 7.65571 3.11737 8.2959 3.05782 9.02475C2.99922 9.74193 3 10.6298 3 11.7334H5ZM5.73005 4.87834C4.78924 5.35771 4.02433 6.12261 3.54497 7.06342L5.32698 7.9714C5.6146 7.40692 6.07354 6.94797 6.63803 6.66035L5.73005 4.87834ZM27 11.7334V26.6667H29V11.7334H27Z"
        fill="#98A2B3"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.WHATSAPP_OUTLINE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.9936 4.00001C9.37007 4.00141 4.00179 9.37479 4.00319 16.0017C4.00366 18.2964 4.66182 20.5429 5.89953 22.4747L4.03365 27.3184C3.93428 27.576 4.06246 27.8655 4.31993 27.9649C4.37751 27.9871 4.43864 27.9985 4.50034 27.9984C4.55759 27.9987 4.61441 27.9889 4.66824 27.9694L9.66531 26.1845C15.2875 29.6879 22.6839 27.9679 26.1855 22.3427C29.687 16.7174 27.9679 9.31728 22.3456 5.8139C20.4398 4.62626 18.2389 3.9978 15.9936 4.00001Z"
        stroke="#98A2B3"
        stroke-width="2"
      />
      <path
        d="M22.3568 18.2788C22.3568 18.2788 20.9957 17.6121 20.1435 17.1677C19.1791 16.671 18.0457 17.601 17.5124 18.1299C16.6824 17.8111 15.9243 17.3298 15.2824 16.7144C14.6669 16.0727 14.1856 15.3145 13.8669 14.4844C14.3958 13.95 15.3235 12.8178 14.8291 11.8533C14.3902 11 13.718 9.64004 13.718 9.63894C13.6237 9.45176 13.4321 9.33358 13.2225 9.33337H12.1114C10.4933 9.61285 9.3168 11.0247 9.33368 12.6667C9.33368 14.4111 11.4214 17.7622 12.8292 19.171C14.237 20.5798 17.588 22.6665 19.3335 22.6665C20.9755 22.6834 22.3874 21.5069 22.6668 19.8888V18.7777C22.667 18.5659 22.5468 18.3724 22.3568 18.2788Z"
        stroke="#98A2B3"
        stroke-width="2"
        stroke-linejoin="round"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.PUSH_LEFT_OUTLINE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0001 14.6667H6.00008C2.66675 14.6667 1.33341 13.3333 1.33341 10V6C1.33341 2.66667 2.66675 1.33333 6.00008 1.33333H10.0001C13.3334 1.33333 14.6667 2.66667 14.6667 6V10C14.6667 13.3333 13.3334 14.6667 10.0001 14.6667Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6 1.33333V14.6667"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.3333 10.6667L9.37369 8.70711C8.98317 8.31658 8.98317 7.68342 9.37369 7.29289L11.3333 5.33333"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.MONEY_FORBIDDEN_OUTLINE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.33301 10.1334V6.00008C2.33301 3.66675 3.66634 2.66675 5.66634 2.66675H12.333C14.333 2.66675 15.6663 3.66675 15.6663 6.00008V10.0001C15.6663 12.3334 14.333 13.3334 12.333 13.3334H6.66634"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.99967 9.66659C9.92015 9.66659 10.6663 8.92039 10.6663 7.99992C10.6663 7.07944 9.92015 6.33325 8.99967 6.33325C8.0792 6.33325 7.33301 7.07944 7.33301 7.99992C7.33301 8.92039 8.0792 9.66659 8.99967 9.66659Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.333 6.33325V9.66659"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.00033 11.9999C7.00033 12.4999 6.86031 12.9733 6.61365 13.3733C6.15365 14.1466 5.30699 14.6666 4.33366 14.6666C3.36033 14.6666 2.51367 14.1466 2.05367 13.3733C1.807 12.9733 1.66699 12.4999 1.66699 11.9999C1.66699 10.5266 2.86033 9.33325 4.33366 9.33325C5.80699 9.33325 7.00033 10.5266 7.00033 11.9999Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.16667 10.1667L2.5 13.8334"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.BAG_OUTLINE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.01015 9.74523C2.04524 9.52447 2.04306 9.29939 2.00372 9.07934L1.61387 6.8988C1.48718 6.19018 2.16181 5.60236 2.84642 5.82486V5.82486C6.19634 6.91358 9.80497 6.91358 13.1549 5.82486V5.82486C13.8395 5.60236 14.5141 6.19017 14.3874 6.8988L13.9976 9.07934C13.9582 9.29939 13.9561 9.52447 13.9911 9.74523L14.2567 11.4159C14.4635 12.7177 13.3765 13.8601 12.066 13.7182L10.8009 13.5811C8.93952 13.3795 7.06178 13.3795 5.20037 13.5811L3.93527 13.7182C2.6248 13.8601 1.53776 12.7177 1.74465 11.4159L2.01015 9.74523Z"
        stroke="currentColor"
        stroke-width="1.5"
      />
      <path
        d="M12 6V3C12 2.44772 11.5523 2 11 2H5C4.44772 2 4 2.44772 4 3V6"
        stroke="currentColor"
        stroke-width="1.5"
      />
      <path
        d="M8 2V4"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M5.33398 10.6667V10.6667C7.08482 10.229 8.91648 10.229 10.6673 10.6667V10.6667"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.TICK_STAR_OUTLINE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.9834 10.0001L8.99173 12.0167L13.0167 7.9834"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.9584 2.0416C9.5334 1.54993 10.4751 1.54993 11.0584 2.0416L12.3751 3.17493C12.6251 3.3916 13.0917 3.5666 13.4251 3.5666H14.8417C15.7251 3.5666 16.4501 4.2916 16.4501 5.17493V6.5916C16.4501 6.9166 16.6251 7.3916 16.8417 7.6416L17.9751 8.95827C18.4667 9.53327 18.4667 10.4749 17.9751 11.0583L16.8417 12.3749C16.6251 12.6249 16.4501 13.0916 16.4501 13.4249V14.8416C16.4501 15.7249 15.7251 16.4499 14.8417 16.4499H13.4251C13.1001 16.4499 12.6251 16.6249 12.3751 16.8416L11.0584 17.9749C10.4834 18.4666 9.54173 18.4666 8.9584 17.9749L7.64173 16.8416C7.39173 16.6249 6.92506 16.4499 6.59173 16.4499H5.15006C4.26673 16.4499 3.54173 15.7249 3.54173 14.8416V13.4166C3.54173 13.0916 3.36673 12.6249 3.1584 12.3749L2.0334 11.0499C1.55007 10.4749 1.55007 9.5416 2.0334 8.9666L3.1584 7.6416C3.36673 7.3916 3.54173 6.92494 3.54173 6.59994V5.1666C3.54173 4.28327 4.26673 3.55827 5.15006 3.55827H6.59173C6.91673 3.55827 7.39173 3.38327 7.64173 3.1666L8.9584 2.0416Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.RECEIPT_SEARCH_OUTLINE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.0827 9.41674V5.86676C17.0827 2.50842 16.2993 1.66675 13.1493 1.66675H6.84935C3.69935 1.66675 2.91602 2.50842 2.91602 5.86676V15.2501C2.91602 17.4667 4.13269 17.9917 5.60769 16.4084L5.61601 16.4001C6.29934 15.6751 7.34101 15.7334 7.93267 16.5251L8.77435 17.6501"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.1667 17.8333C16.6394 17.8333 17.8333 16.6394 17.8333 15.1667C17.8333 13.6939 16.6394 12.5 15.1667 12.5C13.6939 12.5 12.5 13.6939 12.5 15.1667C12.5 16.6394 13.6939 17.8333 15.1667 17.8333Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.3333 18.3333L17.5 17.5"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.66602 5.83325H13.3327"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.5 9.16675H12.5"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.TASK_SQUARE">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7933 1.33325H5.20659C2.77992 1.33325 1.33325 2.77992 1.33325 5.20659V10.7933C1.33325 13.2199 2.77992 14.6666 5.20659 14.6666H10.7933C13.2199 14.6666 14.6666 13.2199 14.6666 10.7933V5.20659C14.6666 2.77992 13.2199 1.33325 10.7933 1.33325ZM6.64659 9.93325L5.14659 11.4333C5.04659 11.5333 4.91992 11.5799 4.79325 11.5799C4.66659 11.5799 4.53325 11.5333 4.43992 11.4333L3.93992 10.9333C3.73992 10.7399 3.73992 10.4199 3.93992 10.2266C4.13325 10.0333 4.44659 10.0333 4.64659 10.2266L4.79325 10.3733L5.93992 9.22659C6.13325 9.03325 6.44659 9.03325 6.64659 9.22659C6.83992 9.41992 6.83992 9.73992 6.64659 9.93325ZM6.64659 5.26659L5.14659 6.76659C5.04659 6.86659 4.91992 6.91325 4.79325 6.91325C4.66659 6.91325 4.53325 6.86659 4.43992 6.76659L3.93992 6.26659C3.73992 6.07325 3.73992 5.75325 3.93992 5.55992C4.13325 5.36659 4.44659 5.36659 4.64659 5.55992L4.79325 5.70659L5.93992 4.55992C6.13325 4.36659 6.44659 4.36659 6.64659 4.55992C6.83992 4.75325 6.83992 5.07325 6.64659 5.26659ZM11.7066 11.0799H8.20659C7.93325 11.0799 7.70659 10.8533 7.70659 10.5799C7.70659 10.3066 7.93325 10.0799 8.20659 10.0799H11.7066C11.9866 10.0799 12.2066 10.3066 12.2066 10.5799C12.2066 10.8533 11.9866 11.0799 11.7066 11.0799ZM11.7066 6.41325H8.20659C7.93325 6.41325 7.70659 6.18659 7.70659 5.91325C7.70659 5.63992 7.93325 5.41325 8.20659 5.41325H11.7066C11.9866 5.41325 12.2066 5.63992 12.2066 5.91325C12.2066 6.18659 11.9866 6.41325 11.7066 6.41325Z"
        fill="currentColor"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.SMS_TRACKING">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.99992 10.8333C2.69992 10.8333 0.833252 12.6916 0.833252 14.9999C0.833252 17.3083 2.69992 19.1666 4.99992 19.1666C7.29992 19.1666 9.16659 17.2999 9.16659 14.9999C9.16659 12.6999 7.30825 10.8333 4.99992 10.8333ZM3.29992 13.2999H4.99992C5.31659 13.2999 5.56659 13.5583 5.56659 13.8666C5.56659 14.1749 5.31659 14.4333 4.99992 14.4333H3.29992C2.98325 14.4333 2.73325 14.1749 2.73325 13.8666C2.73325 13.5583 2.98325 13.2999 3.29992 13.2999ZM6.69992 16.6999H3.29992C2.98325 16.6999 2.73325 16.4416 2.73325 16.1333C2.73325 15.8249 2.99159 15.5666 3.29992 15.5666H6.70825C7.02492 15.5666 7.27492 15.8249 7.27492 16.1333C7.27492 16.4416 7.01659 16.6999 6.69992 16.6999Z"
        fill="currentColor"
      />
      <path
        d="M14.1667 2.5H5.83342C3.33341 2.5 1.66675 3.75 1.66675 6.66667V9.28333C1.66675 9.89167 2.29175 10.275 2.85008 10.0333C3.76675 9.63333 4.80841 9.48333 5.90008 9.65833C8.08342 10.0167 9.86675 11.7417 10.3084 13.9083C10.4334 14.5417 10.4501 15.1583 10.3667 15.75C10.3001 16.2417 10.7001 16.675 11.1917 16.675H14.1667C16.6667 16.675 18.3334 15.425 18.3334 12.5083V6.66667C18.3334 3.75 16.6667 2.5 14.1667 2.5ZM14.5584 7.15833L11.9501 9.24167C11.4001 9.68333 10.7001 9.9 10.0001 9.9C9.30008 9.9 8.59175 9.68333 8.05008 9.24167L5.44175 7.15833C5.17508 6.94167 5.13341 6.54167 5.34175 6.275C5.55841 6.00833 5.95008 5.95833 6.21675 6.175L8.82508 8.25833C9.45842 8.76667 10.5334 8.76667 11.1667 8.25833L13.7751 6.175C14.0417 5.95833 14.4417 6 14.6501 6.275C14.8667 6.54167 14.8251 6.94167 14.5584 7.15833Z"
        fill="currentColor"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.NAV_PENDAPATAN_AGEN">
    <svg width="100%" height="100%" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.5003 3.33337C14.5385 3.32317 14.167 3.75004 14.167 4.63615V9.16671H16.067C16.9448 9.16671 17.5003 8.51856 17.5003 7.49449V6.25004C17.5003 5.83337 17.2503 4.56486 16.8503 4.09171C16.4448 3.62504 15.9694 3.33835 15.5003 3.33337Z"
        attr.fill="url({{ '#paint0_linear_pendapatan_' + unique }})"
      />
      <path
        d="M15 2.5C14.149 2.5 13.3333 3.19211 13.333 4.03809V17.1162C13.3328 17.7467 12.6063 18.108 12.0957 17.7314L10.7725 16.7471C10.4707 16.5163 10.0365 16.5472 9.76562 16.8164L8.46582 18.1084C8.16402 18.4083 7.66892 18.4084 7.36719 18.1084L6.08301 16.8232C5.80443 16.5464 5.37102 16.5163 5.06152 16.7471L3.73828 17.7314C3.22762 18.116 2.50016 17.7546 2.5 17.1162V5.57715C2.5 3.87708 3.27427 2.5 5.5957 2.5H15ZM5.08105 10.625C4.73609 10.6253 4.45605 10.905 4.45605 11.25C4.45606 11.595 4.7361 11.8747 5.08105 11.875H7.09277C7.43777 11.8748 7.71777 11.595 7.71777 11.25C7.71777 10.9049 7.43778 10.6252 7.09277 10.625H5.08105ZM5.08105 8.125C4.73609 8.12525 4.45605 8.40498 4.45605 8.75C4.45606 9.09502 4.7361 9.37475 5.08105 9.375H11.0059C11.3508 9.37477 11.6309 9.09503 11.6309 8.75C11.6309 8.40496 11.3508 8.12523 11.0059 8.125H5.08105ZM5.08105 5.625C4.73609 5.62525 4.45605 5.90498 4.45605 6.25C4.45606 6.59502 4.7361 6.87475 5.08105 6.875H11.0059C11.3508 6.87477 11.6309 6.59503 11.6309 6.25C11.6309 5.90496 11.3508 5.62523 11.0059 5.625H5.08105Z"
        attr.fill="url({{ '#paint0_linear_pendapatan_' + unique }})"
      />
      <defs>
        <linearGradient
          id="{{ 'paint0_linear_pendapatan_' + unique }}"
          x1="10"
          y1="2.5"
          x2="10"
          y2="18.1"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="var(--gradient1)" />
          <stop offset="1" stop-color="var(--gradient2)" />
        </linearGradient>
      </defs>
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.POTONGAN_PPH23">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.83268 1.66663H4.99935C2.49935 1.66663 1.66602 3.15829 1.66602 4.99996V5.83329V17.5C1.66602 18.1916 2.44935 18.5833 2.99935 18.1666L4.42435 17.1C4.75768 16.85 5.22435 16.8833 5.52435 17.1833L6.90768 18.575C7.23268 18.9 7.76602 18.9 8.09102 18.575L9.49102 17.175C9.78268 16.8833 10.2493 16.85 10.5743 17.1L11.9993 18.1666C12.5493 18.575 13.3327 18.1833 13.3327 17.5V3.33329C13.3327 2.41663 14.0827 1.66663 14.9993 1.66663H5.83268ZM5.47435 6.69163C5.93268 6.69163 6.30768 7.06663 6.30768 7.52496C6.30768 7.98329 5.93268 8.35829 5.47435 8.35829C5.01602 8.35829 4.64102 7.98329 4.64102 7.52496C4.64102 7.06663 5.01602 6.69163 5.47435 6.69163ZM9.52435 11.7333C9.05768 11.7333 8.69102 11.3583 8.69102 10.9C8.69102 10.4416 9.06602 10.0666 9.52435 10.0666C9.98268 10.0666 10.3577 10.4416 10.3577 10.9C10.3577 11.3583 9.98268 11.7333 9.52435 11.7333ZM10.216 7.33329L5.66602 11.8833C5.54102 12.0083 5.38268 12.0666 5.22435 12.0666C5.06602 12.0666 4.90768 12.0083 4.78268 11.8833C4.54102 11.6416 4.54102 11.2416 4.78268 11L9.33268 6.44996C9.57435 6.20829 9.97435 6.20829 10.216 6.44996C10.4577 6.69163 10.4577 7.09163 10.216 7.33329Z"
        fill="currentColor"
      />
      <path
        d="M15.009 1.66663V2.91663C15.559 2.91663 16.084 3.14163 16.4673 3.51663C16.8673 3.92496 17.084 4.44996 17.084 4.99996V7.01663C17.084 7.63329 16.809 7.91663 16.184 7.91663H14.584V3.34163C14.584 3.10829 14.7757 2.91663 15.009 2.91663V1.66663ZM15.009 1.66663C14.084 1.66663 13.334 2.41663 13.334 3.34163V9.16663H16.184C17.5007 9.16663 18.334 8.33329 18.334 7.01663V4.99996C18.334 4.08329 17.959 3.24996 17.359 2.64163C16.7507 2.04163 15.9257 1.67496 15.009 1.66663C15.009 1.66663 15.0173 1.66663 15.009 1.66663Z"
        fill="currentColor"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.PENDAPATAN_BERSIH">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3329 9.14163V10.8583C18.3329 11.3166 17.9662 11.6916 17.4995 11.7083H15.8662C14.9662 11.7083 14.1412 11.05 14.0662 10.15C14.0162 9.62496 14.2162 9.13329 14.5662 8.79163C14.8745 8.47496 15.2995 8.29163 15.7662 8.29163H17.4995C17.9662 8.30829 18.3329 8.68329 18.3329 9.14163Z"
        fill="currentColor"
      />
      <path
        d="M17.0577 12.9583H15.866C14.2827 12.9583 12.9493 11.7666 12.816 10.25C12.741 9.38329 13.0577 8.51663 13.691 7.89996C14.2243 7.34996 14.966 7.04163 15.766 7.04163H17.0577C17.2993 7.04163 17.4993 6.84163 17.4743 6.59996C17.291 4.57496 15.9493 3.19163 13.9577 2.95829C13.7577 2.92496 13.5493 2.91663 13.3327 2.91663H5.83268C5.59935 2.91663 5.37435 2.93329 5.15768 2.96663C3.03268 3.23329 1.66602 4.81663 1.66602 7.08329V12.9166C1.66602 15.2166 3.53268 17.0833 5.83268 17.0833H13.3327C15.666 17.0833 17.2743 15.625 17.4743 13.4C17.4993 13.1583 17.2993 12.9583 17.0577 12.9583ZM10.8327 8.12496H5.83268C5.49102 8.12496 5.20768 7.84163 5.20768 7.49996C5.20768 7.15829 5.49102 6.87496 5.83268 6.87496H10.8327C11.1743 6.87496 11.4577 7.15829 11.4577 7.49996C11.4577 7.84163 11.1743 8.12496 10.8327 8.12496Z"
        fill="currentColor"
      />
    </svg>
  </ng-container>
  <ng-container *ngSwitchCase="ICON_TYPE.PENDAPATAN_KOTOR">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.9758 5.53335C15.6174 3.72502 14.2758 2.93335 12.4091 2.93335H5.09245C2.89245 2.93335 1.42578 4.03335 1.42578 6.60002V10.8917C1.42578 12.7417 2.18411 13.825 3.43411 14.2917C3.61745 14.3583 3.81745 14.4167 4.02578 14.45C4.35911 14.525 4.71745 14.5583 5.09245 14.5583H12.4174C14.6174 14.5583 16.0841 13.4583 16.0841 10.8917V6.60002C16.0841 6.20835 16.0508 5.85835 15.9758 5.53335ZM4.60911 10C4.60911 10.3417 4.32578 10.625 3.98411 10.625C3.64245 10.625 3.35911 10.3417 3.35911 10V7.50002C3.35911 7.15835 3.64245 6.87502 3.98411 6.87502C4.32578 6.87502 4.60911 7.15835 4.60911 7.50002V10ZM8.75078 10.95C7.53411 10.95 6.55078 9.96668 6.55078 8.75002C6.55078 7.53335 7.53411 6.55002 8.75078 6.55002C9.96745 6.55002 10.9508 7.53335 10.9508 8.75002C10.9508 9.96668 9.96745 10.95 8.75078 10.95ZM14.1341 10C14.1341 10.3417 13.8508 10.625 13.5091 10.625C13.1674 10.625 12.8841 10.3417 12.8841 10V7.50002C12.8841 7.15835 13.1674 6.87502 13.5091 6.87502C13.8508 6.87502 14.1341 7.15835 14.1341 7.50002V10Z"
        fill="currentColor"
      />
      <path
        d="M18.5841 9.09995V13.3916C18.5841 15.9583 17.1174 17.0666 14.9091 17.0666H7.59245C6.96745 17.0666 6.40912 16.9749 5.92578 16.7916C5.53412 16.6499 5.19245 16.4416 4.91745 16.1749C4.76745 16.0333 4.88412 15.8083 5.09245 15.8083H12.4091C15.4925 15.8083 17.3258 13.9749 17.3258 10.8999V6.59995C17.3258 6.39995 17.5508 6.27495 17.6924 6.42495C18.2591 7.02495 18.5841 7.89995 18.5841 9.09995Z"
        fill="currentColor"
      />
    </svg>
  </ng-container>
</ng-container>
